
<html>
<head>
<meta charset="utf-8">
<title>WHS | Channel Community Partner</title>
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0"/>
<meta name="format-detection" content="telephone=no">
<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous" />
<script type="text/javascript" src="../assets/fljs/jquery.min.js"></script>
<link rel="shortcut icon" type="image/x-icon" href="../assets/FLimages/favicon.ico">
<style>
  * {
    box-sizing: border-box;
  }
  
  .columns {
    float: left;
    width: 275px;
    padding: 6px;
  }
  
  .price {
    list-style-type: none;
    border: 1px solid #eee;
    margin: 0;
    padding: 0;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  
  .price:hover {
    box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2)
  }
  
  .price .header {
    background-color: #111;
    color: white;
    font-size: 20px;
  }
  
  .price li {
    border-bottom: 1px solid #eee;
    padding: 10px;
    text-align: left;
    font-size: 14px;
  }
  
  .price .grey {
    background-color: #eee;
    font-size: 16px;
  }
  
  .button {
    background-color: #B5D220;
    border: none;
    color: white;
    padding: 10px 25px;
    text-align: center;
    text-decoration: none;
    font-size: 18px;
    border-radius: 4px;
  }
  
  @media only screen and (max-width: 600px) {
    .columns {
      width: 100%;
    }
  }

  .termsx {

    overflow-y: scroll;

    height: 250px;

    width: 100%;

    border: 1px solid #DDD;

    padding: 10px;

    font-size: 11px;

    }

    
  .distac {

    overflow-y: scroll;

    width: 100%;

    border: 1px solid #DDD;

    padding: 10px;
   
    }

    .removeBottomMargin{
      width:350px;margin-bottom: -1.25em;
    }
  </style>
</head>

<body>
  <form id="form1" runat="server">
       <div class="container-fluid">
  <!-- Control the column width, and how they should appear on different devices -->
           
           <div class="fixed-top" style="width:227px;"><a style="top:auto;" href="/new"><img src="../assets/FLimages/logo.png" alt=""/></a></div>
<div class="row" style="padding-left:0; background-color:#f3f9fa;">
<div class="col">
         <div class="row" style="padding-left:0;">
               <div style="background-color:#f3f9fa; height:86px; width:205px;">
                   
                   </div>
               <!--<div class="col-sm-2" style="background-color:black; height: 62px; min-width:205px;">
                  <select class="cs-select cs-skin-border">
                      <option>IT / Var</option>
                      <option>Photography</option>
                      <option>Mobile</option>
                      <option>Datacenter</option>
                      <option>POS</option>
                      <option>Electronics</option>
                      <option>IC Components</option>
                  </select>
              </div>-->
        <div class="col-sm-4" style="background-color:#2B2B2B; height: 62px; min-width:400px;">
            <!--<div class="Bannersearch headsearch" >
              <input type="text" placeholder="Functionality coming soon">
              <input type="submit" name="Submit" value="Submit">
            </div>-->
        </div>
        <div class="col" style="background-color:#2B2B2B; height: 62px; min-width:400px;">
          <div class="TopRight">
              <ul>
                 <!--<li>
                  <select class="cs-select cs-skin-elastic">
                    <option value="Canada">Canada</option>
                    <option value="USA">USA</option>
                    <option value="brazil">Brazil</option>
                  </select>
                </li>-->
                <li><a href="https://whscorp.com/join_channel.aspx">Register</a></li>
                <li class="SignIn"><a href="https://whscorp.com/login.aspx">Sign In</a></li>
              </ul>
            </div>
        </div>
      </div>

</div>
</div>


  <div class="row">
    <div class="col-sm" style="background-color:#f3f9fa;"></div><!--yellow-->
    <div class="col-sm-8" style="background-color:#f3f9fa;"><!--orange-->
      <div class="reGister">
        <div class="wrapper">
          <h1>Register</h1>
          
            <div class="rgstrDiv">
             <div class="rgstrForm">
              <form class="regform" action="" method ="get">
               <div class="tabList">
                 <ul id="progressbar">
                   <li [ngClass]="{'active': step1===true}"><span>1</span> Step</li>
                   <li [ngClass]="{'active': step2===true}"><span>2</span> Step</li>
                   <li [ngClass]="{'active': step3===true}"><span>3</span> Step</li>   
                   <li [ngClass]="{'active': step4===true || step5===true || stepEndUserConfirm===true || stepDistributorConfirm===true || stepComingSoon===true || stepAnyEmailExist===true}"><span>4</span> Step</li>                
                 </ul>
               </div>
                
                <fieldset id="first" style="width: 890px;">
                      <div class="row" *ngIf="step1===true">
                        <div class="col-sm-8"  >
                            <form class="example-form"><br>
                              <mat-form-field style="width:350px;">
                                <mat-label>Email</mat-label>
                                  <input matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher"
                                        placeholder="Ex. pat@example.com">                            
                                  <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                                    Please enter a valid email address
                                  </mat-error>
                                  <mat-error *ngIf="emailFormControl.hasError('required')">
                                    Email is <strong>required</strong>
                                  </mat-error>
                                  <mat-error  *ngIf="emailFormControl.errors">
                                    <span *ngIf="emailFormControl.errors.emailDomain">
                                      Email cannot be a <strong>free email account</strong>
                                    </span>            
                                </mat-error>   
                              </mat-form-field>
                            </form>
                        </div>
                        <div class="col-sm-1">
                           {{test|json}} <button mat-raised-button color="Next" class="next_btn" [disabled]="emailFormControl.errors" (click)="step1Next()">Next</button>
                        </div>
                      </div>
                           
                      <div class="rgstrTxt" *ngIf="step5===true">                       
                        <h2>You’re all set!</h2>
                        <p>Please check your email to continue your registration process.  Thank you for your interest in WHS and the Channel Partner Alliance.</p>                        
                        <a href="https://whscorp.com/login.aspx" class="button">Sign in</a>
                      </div>

                      <div class="rgstrTxt" *ngIf="stepAnyEmailExist===true">                       
                        <h2>Thank you for your interest.</h2>
                        <p>Instructions on how to access the application have been sent to you by email.  Please check your spam folder as well.
                        </p>                        
                        <a href="https://whscorp.com/login.aspx" class="button">Sign in</a>
                      </div>

                      <div class="rgstrTxt" *ngIf="step4===true">
                        <h2>Registration complete - Thank you.</h2>
                        <p>You may start using the system immediately.  Please check your email for information on how to gain access to the site.  Email is sent immediately; please verify your spam folder.</p>                        
                        <a href="https://whscorp.com/login.aspx" class="button">Sign in</a>
                      </div>

                      <div class="rgstrTxt" *ngIf="stepEndUserConfirm===true">
                        <h2>Thank you for your interest.</h2>
                        <p>End users such as home users and corporate buyers can use our search engine from our home page to locate the products they need and connect with a local partner to further assist them with the installation and implementation of their solution.  </p>                        
                        <a href="https://whscorp.com/new/corporate-retail-purchase.aspx" class="button">Find a Partner</a>
                      </div>
                      <div class="rgstrTxt" *ngIf="stepDistributorConfirm===true">
                        <h2>Thank you for your interest.
                        </h2>
                        <p>One of our dedicated representatives will contact you to open an account as a distributor or a manufacturer (vendor) and tell you more about what the Channel Partner Alliance (WHS) can do for your business.
                        </p>                        
                        <a href="https://whscorp.com/new/contact-us.aspx" class="button">Contact Us</a>
                      </div>
                      <div class="rgstrTxt" *ngIf="stepComingSoon===true">
                        <h2>Reseller Registration
                        </h2>
                        <p>Reseller Registration is coming soon.
                        </p>                        
                        <a href="https://whscorp.com/new/contact-us.aspx" class="button">Contact Us</a>
                      </div>
                      
                     

                      <div *ngIf="step3===true">
                        <div class="rgstrFields" >
                          <ul>
                            <li class="full"><label><b>Email Address*</b>&nbsp;:&nbsp;<span *ngIf="this.emailFormControl">{{this.emailFormControl.value}}</span></label>
                          
                            
                             
                           
                              <span *ngIf="isManuEmailAlreadyExists===true || isDistEmailAlreadyExists===true || stepResellerResgister===true">
                                <label>
                                  <b>Account Type*</b>&nbsp;:&nbsp;
                                  <span *ngIf="accountTypeFormControl.value===1 && stepResellerResgister===false">Distributor</span>
                                  <span *ngIf="accountTypeFormControl.value===2 && stepResellerResgister===false">Manufacturer</span>
                                  <span *ngIf="stepResellerResgister===true">
                                    Reseller
                                  </span>
                                </label>
                              </span>

                              <span *ngIf="stepResellerResgister===true">
                                <label>
                                  <b>Group</b>&nbsp;:&nbsp;CPA
                                </label>
                              </span>

                                <span *ngIf="isManuEmailAlreadyExists===false && isDistEmailAlreadyExists===false && stepResellerResgister===false">
                                  <mat-form-field style="width: 200px;">
                                  <mat-label>Account Type</mat-label>
                                  <select matNativeControl  [formControl]="accountTypeFormControl" required>                                  
                                    <option value="1">
                                      Distributor
                                    </option>
                                    <option value="2">
                                      Manufacturer
                                    </option>
                                  </select>
                                </mat-form-field>
                               
                                <mat-error *ngIf="accountTypeFormControl.hasError('required')">
                                  Account type is <strong>required</strong>
                                </mat-error>
                              </span>  
                            
                            </li>
                            <li>  
                              <mat-form-field style="width:350px;">
                                <mat-label>First Name</mat-label>
                                  <input matInput [formControl]="firstNameFormControl" [errorStateMatcher]="matcher">    
                                  <mat-error *ngIf="firstNameFormControl.hasError('required')">
                                    First Name is <strong>required</strong>
                                  </mat-error>
                              </mat-form-field>
                            </li>
                            <li>
                              <mat-form-field style="width:350px;">
                                <mat-label>Last Name</mat-label>
                                  <input matInput [formControl]="lastNameFormControl" [errorStateMatcher]="matcher">    
                                  <mat-error *ngIf="lastNameFormControl.hasError('required')">
                                    Last Name is <strong>required</strong>
                                  </mat-error>
                              </mat-form-field>

                            

                              
                            </li>
                            <li>
                              <mat-form-field style="width:350px;">
                                <mat-label>Job Title</mat-label>
                                  <input matInput [formControl]="jobTitleFormControl" [errorStateMatcher]="matcher" maxlength="25">    
                                  <mat-error *ngIf="lastNameFormControl.hasError('required')">
                                    Job Title is <strong>required</strong>
                                  </mat-error>
                              </mat-form-field>                              
                            </li>
                            <li *ngIf="accountDoesntExist===false || stepResellerResgister===true">
                                <mat-form-field [ngClass]="{'removeBottomMargin': isUserIdAlreadyExistsMsg===true}">
                                  <mat-label>User ID</mat-label>
                                    <input matInput [formControl]="userNameFormControl" [errorStateMatcher]="matcher">    
                                    <mat-error *ngIf="userNameFormControl.hasError('required')">
                                      User ID is <strong>required</strong>
                                    </mat-error>
                                    <mat-error  *ngIf="userNameFormControl.errors">
                                      <span *ngIf="userNameFormControl.errors.emailDomain">
                                        Email cannot be a <strong>free email account</strong>
                                      </span>            
                                  </mat-error> 
                                </mat-form-field> 
                                <span *ngIf="isUserIdAlreadyExistsMsg===true" style="color: red; font-size: 12px;">
                                  <br>User ID already exists.
                                </span>    
                              </li>
                              <li>
                              
                              <mat-form-field style="width:225px;" *ngIf="accountDoesntExist===true">
                                <mat-label>Phone Number</mat-label>
                                  <input matInput [formControl]="phoneNumberFormControl" [textMask]="{mask: datemask}"  [errorStateMatcher]="matcher">    
                                  <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
                                    Phone Number is <strong>required</strong>
                                  </mat-error>
                                  <mat-error *ngIf="phoneNumberFormControl.hasError('pattern')">
                                    Phone Number is <strong>invalid</strong><br>(e.g.: 514-392-9111).
                                  </mat-error>                                  
                              </mat-form-field> 
&nbsp;
                               <mat-form-field style="width:125px;" *ngIf="accountDoesntExist===true">
                                <mat-label>Phone Extension</mat-label>
                                  <input matInput [formControl]="phoneExtNumberFormControl" [errorStateMatcher]="matcher">   
                              </mat-form-field> 
                            </li>
                            <li *ngIf="stepResellerResgister===true">
                            

                              <mat-form-field style="width:350px;">
                                <mat-label>Company Name</mat-label>
                                  <input matInput [formControl]="companyNameFormControl" [errorStateMatcher]="matcher">   
                                  <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
                                    Company Name is <strong>required</strong>
                                  </mat-error>
                              </mat-form-field> 

                            </li>

                            <li *ngIf="stepResellerResgister===true">

                              <mat-form-field style="width:350px;">
                                <mat-label>Address 1</mat-label>
                                  <input matInput [formControl]="address1FormControl" [errorStateMatcher]="matcher">   
                                  <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
                                    Address 1 is <strong>required</strong>
                                  </mat-error>
                              </mat-form-field> 

                            
                            </li>

<li *ngIf="stepResellerResgister===true">
  <mat-form-field style="width:350px;">
    <mat-label>Address 2</mat-label>
      <input matInput [formControl]="address2FormControl" [errorStateMatcher]="matcher">   
  </mat-form-field> 


</li>

<li *ngIf="stepResellerResgister===true">
  <mat-form-field style="width:350px;">
    <mat-label>City</mat-label>
      <input matInput [formControl]="cityFormControl" [errorStateMatcher]="matcher">   
      <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
        City is <strong>required</strong>
      </mat-error>
  </mat-form-field> 

</li>

<li *ngIf="stepResellerResgister===true">

  <mat-form-field style="width:350px;">
    <mat-label>Zip / Postal Code</mat-label>
      <input matInput [formControl]="postalCodeFormControl" [errorStateMatcher]="matcher">  
      <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
        Zip / Postal Code is <strong>required</strong>
      </mat-error> 
  </mat-form-field> 


</li>

<li *ngIf="stepResellerResgister===true">
  <mat-form-field style="width:350px;">
    <mat-select placeholder="Country" [formControl]="countryFormControl" required (selectionChange)="loadProvinces($event.value)" >
      <mat-option *ngFor="let cnt of countries" [value]="cnt.id">{{cnt.name}}</mat-option>
    </mat-select>                                                    
  </mat-form-field> 
</li>

<li *ngIf="stepResellerResgister===true">
  <mat-form-field style="width:350px;">
    <mat-select placeholder="Province / State" [formControl]="provinceFormControl" required  >
      <mat-option *ngFor="let prv of provinces" [value]="prv.name">{{prv.name}}</mat-option>
    </mat-select>
  </mat-form-field>

  <!--<mat-form-field style="width: 200px;">
    <mat-label>State / Province</mat-label>
    <select matNativeControl  >
      <option value="1">
        Ontario
      </option>
      <option value="2">
        Quebec
      </option>     
    </select>
  </mat-form-field>-->

</li>
                            <li class="full"  *ngIf="stepResellerResgister===true">
                              
                        <div  *ngIf="stepResellerResgister===true">

                              <b>Distributor / Manufacturer Authorization</b>
                             <div class="termsx">
                              <span style="background-color:yellow;">(Version française incluse au bas de la page)</span><br><br>

                              Please read this section carefully.<br><br>
                              
                              Registration to the CPA can only be completed by the company owner, the president of the CEO of the company. If you are not the CEO or the business owner please click on the cancel button below to quit the registration process and have the CEO or owner do the initial registration for your company. If you are the correct person to complete this process, please enter you name and title below and continue with the registration process. 
                              <br><br>
                              ###<br><br>
                              
                              Veuillez lire attentivement cette section. L'enregistrement auprès de la CPA ne peut être complété que par le propriétaire de l'entreprise, le président ou le PDG de l'entreprise. Si vous n'êtes pas le PDG ou le propriétaire de l'entreprise, veuillez cliquer sur le bouton « Annuler » ci-dessous pour quitter le processus d'enregistrement et demander au PDG ou au propriétaire de procéder à l'enregistrement de votre entreprise. Si vous êtes la bonne personne pour compléter ce processus, veuillez entrer votre nom et titre ci-dessous et continuer le processus d'enregistrement. 
                              
                              </div>
                              <br><br>

                              <b>Distributor / Manufacturer Authorization</b>
                              <div class="termsx">
                                <span style="background-color:yellow;">((Version française incluse au bas de la page))</span><br><br>

                                Members expressly acknowledge, agree and understand that WHSCorp, also known as The Channel Partner Alliance (CPA) collects MDF (marketing development funds) from distributors and manufacturers based on their purchases. MDF percentages vary by distributor and manufacturer. The marketing development funds that are collected are used for different types of marketing initiatives by the CPA. The following list represent some of the marketing and development activities managed by the CPA and available to you as a member: 
                                <br><br>
                                • Live Mastermind conferences <br>
                                • Accommodations for Mastermind events <br>
                                • Access to resources VAR office suite / MSP Office 5 <br>
                                • Elite 300 business tools <br>
                                • 12 yearly Master Classes <br>
                                • WHS e-procurement tool <br>
                                •More...  <br><br>

                                As more marketing development funds are collected, our group members will be entitled to greater membership levels in the elite 300 Mastermind Group. <br><br>

                                For more information or details regarding these programs, contact us by phone or by email.<br><br>

                                ###<br><br>

                                Les membres reconnaissent, acceptent et comprennent expressément que WHSCorp, également connue sous le nom de la Channel Partner Alliance (CPA) ou l'Alliance des partenaires de distribution, recueille des fonds FDM (fonds de développement marketing) auprès des distributeurs et des fabricants en fonction de leurs achats. Les pourcentages de FDM varient selon le distributeur et le fabricant. Les fonds de développement marketing qui sont recueillis sont utilisés pour différents types d'initiatives de marketing par la CPA. La liste suivante représente quelques-unes des activités de marketing et de développement gérées par la CPA et mises à votre disposition en tant que membre : 
                                <br><br>
                                • Les conférences Mastermind en direct ; <br>
                                • L'hébergement durant les événements Mastermind ; <br>
                                • L'accès aux ressources VAR office suite / MSP Office 5 ; <br>
                                • Les outils d'affaires Elite 300 ; <br>
                                • 12 classes de maître par an ; <br>
                                • L'outil d'approvisionnement électronique WHS ; <br>
                                • Et bien plus.<br><br>

                                À mesure que les fonds de développement marketing sont collectés, les membres de notre groupe auront droit à des niveaux d'adhésion plus élevés dans le groupe Mastermind Elite 300. <br><br>

                                Pour plus d'informations ou de détails sur ces programmes, contactez-nous par téléphone ou par courriel.
                              </div>
                              <br><br>
                              <b>Distributor Account #s:</b>
                                <br> 
                                <div class="distac">       
                                  <ul>
                                        <li style="font-weight: bold;">
                                            Canada Distributor Account #s
                                        </li>
                                        <li style="font-weight: bold;">
                                            USA Distributor Account #s    
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Synnex Account #<span style="color: red;"> {{CAStar}}</span></mat-label>
                                                <input matInput [formControl]="synnexCAFormControl" [errorStateMatcher]="matcher"> 
                                            </mat-form-field>
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Synnex Account #<span style="color: red;"> {{USAStar}}</span></mat-label>
                                                <input matInput [formControl]="synnexUSAFormControl" [errorStateMatcher]="matcher">   
                                            </mat-form-field>  
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Tech Data Account #</mat-label>
                                                <input matInput [formControl]="techdataCAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field> 
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Tech Data Account #</mat-label>
                                                <input matInput [formControl]="techdataUSAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field>      
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Ingram Micro Account #</mat-label>
                                                <input matInput [formControl]="ingrammicroCAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field> 
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>Ingram Micro Account #</mat-label>
                                                <input matInput [formControl]="ingrammicroUSAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field>     
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>D&H Account #</mat-label>
                                                <input matInput [formControl]="dandhCAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field>
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>D&H Account #</mat-label>
                                                <input matInput [formControl]="dandhUSAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field>
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>ASI Account #</mat-label>
                                                <input matInput [formControl]="asiCAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field> 
                                        </li>
                                        <li>
                                            <mat-form-field style="width:175px;">
                                                <mat-label>ASI Account #</mat-label>
                                                <input matInput [formControl]="asiUSAFormControl" [errorStateMatcher]="matcher">                                        
                                            </mat-form-field>  
                                        </li>                                     
                                    </ul>   
                                </div>  
                                <br><br>

                              <b>Terms and Conditions</b>
                               <div class="termsx">
                                <p>
                                  <span style="background-color:yellow;">(Version française incluse au bas de la page)</span>
                              </p>
                              <p>
                                  Members of the WHS Elite program (which includes Elite300Mastermind +
                                  Channel Next events) and also known as the Channel Partner Alliance must
                              read and accept the following sections: Section (1) “    <strong>WHSCorp Terms and Conditions”</strong>, Section (2) “
                                  <strong>
                                      CHANNEL PARTNER ALLIANCE TERMS &amp; CONDITIONS FOR ELITE 300
                                      MASTERMIND MEMBERSHIP PROGRAM AS OF NOVEMBER 2018”
                                  </strong>
                                  and Section (3) “<strong>JOINT TERMS AND CONDITIONS OF USE”<u></u></strong>
                              </p>
                              <p>
                                  Members of the WHS PRO program must read and accept the following section:
                                  Section (1) “<strong>WHSCorp Terms and Conditions”</strong>
                              </p>
                              <p>
                                  Members of the WHS SOLO program must read and accept the following section:
                                  Section (1) “<strong>WHSCorp Terms and Conditions”</strong>
                              </p>
                              <p>
                                  <strong><u>SECTION 1:</u></strong>
                              </p>
                              <p>
                                  <strong>WHSCorp Terms and Conditions</strong>
                              </p>
                              <p>
                                  <strong>1. Accepting the WHSCorp Terms &amp; Conditions</strong>
                              </p>
                              <p>
                                  This Member Agreement (the “Agreement”) is a contract between you (the
                                  “Member”) and 8174563 Canada Inc., a corporation incorporated under the
                                  laws of Canada (“WHSCorp”, “we” or “us”). You must read, agree with and
                                  accept all of the terms and conditions contained in this Agreement in order
                              to use our website located at    <a href="http://www.whscorp.com/">www.whscorp.com</a> (the “Site”) and
                                  related software and services (collectively with the Site, the “WHSCorp
                                  Platform”).
                              </p>
                              <p>
                                  WHSCorp may make modifications, deletions and/or additions to this
                                  Agreement (“Changes”) at any time. Changes will be effective: (i) thirty
                                  (30) days after WHSCorp provides notice of the Changes, whether such notice
                                  is provided through the Site user interface, is sent to the email address
                                  associated with your account or otherwise; or (ii) when you opt-in or
                                  otherwise expressly agree to the Changes or a version of this Agreement
                                  incorporating the Changes, whichever comes first.<strong></strong>
                              </p>
                              <p>
                                  Your access to and use of the WHSCorp Platform is also governed by
                                  information, guidelines and policies made available on the Site, including
                              but not limited to the WHSCorp Privacy Policy, which can be accessed at    <a href="http://www.whscorp.com/privacy">www.whscorp.com/privacy</a>.To the
                                  extent that there are any conflicts between the terms and conditions of
                                  this Agreement and the Site, the terms and conditions of this Agreement
                                  will govern.
                              </p>
                              <p>
                                  YOU UNDERSTAND THAT BY USING THE WHSCORP PLATFORM, YOU ARE AGREEING TO BE
                                  BOUND BY THIS AGREEMENT. IF YOU DO NOT ACCEPT THIS AGREEMENT IN ITS
                                  ENTIRETY, YOU MAY NOT ACCESS OR USE THE WHSCORP PLATFORM. IF YOU AGREE TO
                                  THIS AGREEMENT ON BEHALF OF AN ENTITY, YOU REPRESENT AND WARRANT THAT YOU
                                  HAVE THE AUTHORITY TO BIND THAT ENTITY TO THIS AGREEMENT. THE TERMS
                                  “MEMBER”, “YOU” AND “YOUR” REFER AND APPLY TO THAT ENTITY.
                              </p>
                              <p>
                                  YOU REPRESENT AND WARRANT THAT YOU ARE NOT A CONSUMER AS DEFINED IN ANY
                                  APPLICABLE CANADIAN LAW OR IN ANY OTHER APPLICABLE LAW OF THE NATION, THE
                                  COUNTRY, STATE, PROVINCE OR CITY IN WHICH YOU ARE PRESENT WHILE USING THE
                                  WHS PLATFORM.
                              </p>
                              <p>
                                  YOU REPRESENT AND WARRANT THAT THIS AGREEMENT DOES NOT INTERFERE, CHANGE OR
                                  ALTER ANY PURCHASE AGREEMENT YOU HAVE WITH EACH OF YOUR DISTRIBUTORS OR
                                  WITH ANY THIRD PARTIES.
                              </p>
                              <p>
                                  <strong>2. The WHSCorp Platform</strong>
                              </p>
                              <p>
                                  WHSCorp has created an online aggregator, the "WHSCorp Platform", that
                                  allows the Member to: a) research product pricing and availability
                                  information from multiple Distributor (as defined below) websites for which
                                  it holds an active account; and b) place a Purchase Order (as defined
                                  below) for the selected product with the Distributor. The purchase contract
                                  is formed directly between such Member and the Distributor and we are not a
                                  party to that agreement.
                              </p>
                              <p>
                                  <strong>3. Getting started</strong>
                              </p>
                              <p>
                                  <strong>3.1 Eligibility</strong>
                              </p>
                              <p>
                                  The WHSCorp Platform is available to any legal entities capable of forming
                                  legally binding contracts under applicable law, but excluding consumers as
                                  defined by any law, decree, regulation, treaty or administrative act
                                  applicable to you.
                              </p>
                              <p>
                                  Members agree that they are not (a) a citizen or resident of a country in
                                  which use or participation is prohibited by law, decree, regulation, treaty
                                  or administrative act; (b) a citizen or resident of, or located in, a
                                  country or region that is subject to U.S. or other sovereign country
                                  sanctions or embargoes; or (c) an individual or an individual employed by
                                  or associated with an entity identified on the U.S. Department of
                                  Commerce’s Denied Persons or Entity List, the U.S. Department of Treasury’s
                                  Specially Designated Nationals or Blocked Persons Lists, or the Department
                                  of State’s Debarred Parties List or otherwise ineligible to receive items
                                  subject to Canadian or U.S. export control laws and regulations, or other
                                  economic sanction rules of any sovereign nation.
                              </p>
                              <p>
                                  <strong>3.2 Expectations</strong>
                              </p>
                              <p>
                                  WHSCorp expects a consistent and high level of courtesy, respect and
                                  professionalism from all of its Members toward each other, us and the
                                  Distributors. Members agree to use good judgment when posting information,
                                  comments, or other content regarding other Members and Distributors,
                                  WHSCorp or any third party anywhere within the WHSCorp Platform. Members
                                  may be held legally responsible for damages suffered by other Members and
                                  Distributors, WHSCorp or any third party as a result of legally actionable
                                  or defamatory comments, remarks, or other information or content posted to
                                  the WHSCorp Platform. All Members are to comply with all laws applicable to
                                  them or to their activities, and with all posted WHSCorp Policies, which
                                  are hereby incorporated into this Agreement by reference. These policies
                                  may be modified from time to time at WHSCorp’s discretion, and the
                                  currently effective policies will be deemed to be part of this Agreement.
                              </p>
                              <p>
                                  When using the WHSCorp Platform, you agree not to post or transmit to or
                                  from the WHSCorp Platform:
                              </p>
                              <p>
                                  (i) any unlawful, hateful, racially or ethnically offensive, threatening,
                                  libellous, defamatory, obscene, pornographic, or other material or content
                                  that would violate rights of publicity and/or privacy or that would violate
                                  any law;
                              </p>
                              <p>
                                  (ii) any material or content that infringes, misappropriates or violates
                                  any third party rights, including but not limited to copyright, trademark,
                                  patent right or other proprietary right of any third party;
                              </p>
                              <p>
                                  (iii) any falsehoods or misrepresentations that could damage us, our users
                                  or any third party;
                              </p>
                              <p>
                                  (iv) any private information concerning another person, without their
                                  permission;
                              </p>
                              <p>
                                  (v) anything which impersonates another person or represents yourself as
                                  affiliated with us, our staff or other industry professionals;
                              </p>
                              <p>
                                  (vi) anything which solicits a user's password or other account
                                  information;
                              </p>
                              <p>
                                  (vii) anything which harvests user names, addresses, or email addresses for
                                  any purpose; and
                              </p>
                              <p>
                                  (viii) any viruses or other computer instructions or technological means
                                  whose purpose is to disrupt, damage, or interfere with the use of computers
                                  or related systems.
                              </p>
                              <p>
                                  You will not access (or attempt to access) the WHSCorp Platform by any
                                  means other than the interface provided, and you will not use information
                                  from the WHSCorp Platform for any purpose other than the purpose for which
                                  it was made available. You will not engage in any activity that interferes
                                  with or disrupts the functioning of the WHSCorp Platform. You will not
                                  upload or attach an invalid or malicious or unknown file. You will not
                                  insert any external links that may be malicious or unknown to you, or used
                                  for offering any goods or services.
                              </p>
                              <p>
                                  You do further hereby agree to use the WHSCorp Platform for lawful purposes
                                  only, and not for any immoral or harmful activities. You agree that you
                                  will not do any of the following while using or accessing the WHSCorp
                                  Platform:
                              </p>
                              <p>
                                  (i) attempt to access or search the WHSCorp Platform or download content
                                  from the WHSCorp Platform through the use of any engine, software, tool,
                                  agent, device or mechanism (including spiders, robots, crawlers, data
                                  mining tools or the like) other than the software and/or search agents
                                  provided by us or other generally available third party web browsers;
                              </p>
                              <p>
                                  (ii) access, tamper with, or use non-public areas of the WHSCorp Platform,
                                  our computer systems, or the technical delivery systems of our providers;
                              </p>
                              <p>
                                  (iii) gather and use information, such as other users’ names, real names,
                                  email addresses, available through the WHSCorp Platform to transmit any
                                  unsolicited advertising, junk mail, spam or other form of solicitation;
                              </p>
                              <p>
                                  (iv) use the WHSCorp Platform for any commercial purpose or for the benefit
                                  of any third party not contemplated by this Agreement;
                              </p>
                              <p>
                                  (v) violate any applicable law or regulation; or
                              </p>
                              <p>
                                  (vi) advocate, encourage, or assist any other individual to doing any of
                                  the foregoing. We reserve the right to investigate and prosecute violations
                                  of any of the above and/or involve and cooperate with law enforcement
                                  authorities in prosecuting users who violate this Agreement.
                              </p>
                              <p>
                                  WHSCorp is not legally responsible for any remarks, information or other
                                  content posted or made available on the WHSCorp Platform by any Member or
                                  Distributor or third party, even if such information or content is
                                  defamatory or otherwise legally actionable. WHSCorp is not legally
                                  responsible for any negative outcome of the relationship between Members
                                  and Distributors. WHSCorp is not responsible for and does not monitor or
                                  censor content for accuracy or reliability. However, WHSCorp reserves the
                                  right to remove or restrict access to any information or content posted or
                                  made available on the WHSCorp Platform if ordered to do so by a government
                                  authority or if WHSCorp considers such information or content to be in
                                  violation of this Agreement, or to be unlawful, immoral or harmful.
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong>3.3 Identity and Account Security</strong>
                              </p>
                              <p>
                                  All identity information associated with a Member account must be real and
                                  verifiable. WHSCorp reserves the right to validate Member information at
                                  any time, including but not limited to validation against third party
                                  databases or the verification of one or more official government or legal
                                  documents that confirm the Member’s identity. You authorize WHSCorp,
                                  directly or through third parties, to make any inquiries necessary to
                                  validate your identity and confirm your ownership of your email address or
                                  financial instruments. Failure to provide information about you and your
                                  business when requested is a violation of this Agreement.
                              </p>
                              <p>
                                  Each Member may create sub-accounts to be used by its employees (the
                                  “Sub-Account”). Each Sub-Account must be used by only one person. The
                                  Member is solely responsible for ensuring and maintaining the secrecy and
                                  security of the Member account and any Sub-Account passwords. Members agree
                                  not to disclose this(these) password(s) to any third party and shall be
                                  solely responsible for any use of or action taken through the use of such
                                  password(s) on WHSCorp Platform. You must notify WHSCorp Support (
                                  <a href="mailto:support@whscorp.com">
                                      <strong>support@whscorp.com</strong>
                                  </a>
                                  ) immediately if you suspect that any password has been lost or stolen.
                              </p>
                              <p>
                                  By using your Member account, you acknowledge and agree the WHSCorp’s
                                  account security procedures are commercially reasonable. You may not allow
                                  third parties to use this password to perform any action, including but not
                                  limited to, posting jobs, applying for jobs, performing services or selling
                                  goods under your Member account.
                              </p>
                              <p>
                                  <strong>4. Working in WHSCorp Platform</strong>
                              </p>
                              <p>
                                  <strong>4.1 Searching</strong>
                              </p>
                              <p>
                                  With regard to price and stock data on the WHSCorp Platform, WHSCorp solely
                                  relies on the data provided by Distributors. Therefore, the price and stock
                                  data are only indicative and are subject to changes and confirmation. Each
                                  Distributor makes specific and/or Member’s specific data available to its
                                  trading partner like WHSCorp. WHSCorp will communicate data back and forth
                                  from the WHSCorp Platform to the Distributor’s website on behalf of the
                                  Member and as per the Member’s request to provide the Services (as defined
                                  below).
                              </p>
                              <p>
                                  In order to enable WHSCorp to provide the Services under this Agreement,
                                  the Member acknowledges that it will be required to provide WHSCorp with
                                  its XML user account and password information for each of its Distributors
                                  that it would like to use the WHSCorp Platform with.
                              </p>
                              <p>
                                  <strong>4.2 Purchase Orders</strong>
                              </p>
                              <p>
                                  All terms and conditions contained in your agreement with the relevant
                                  Distributor are to be considered the terms and conditions that apply to the
                                  Purchase Order made through the WHSCorp Platform. For greater certainty,
                                  WHSCorp will not be a party to any Purchase Order. The terms and conditions
                                  of this Agreement, however, will govern and supersede any term or condition
                                  in any other agreement between the Member and the Distributor that purports
                                  to expand WHSCorp’s obligations or restrict WHSCorp’s rights under this
                                  Agreement.
                              </p>
                              <p>
                                  <strong>5. Acknowledgements by Members of WHSCorp’s role</strong>
                              </p>
                              <p>
                                  <strong>5.1 Purchase Order</strong>
                              </p>
                              <p>
                                  Members expressly acknowledge, agree and understand that: (i) the WHSCorp
                                  Platform is merely a venue where Members may search for products and place
                                  Purchase Orders with Distributors; (ii) WHSCorp is not a party to any
                                  Purchase Order between Members and Distributors; (iii) WHSCorp shall not
                                  have any liability or obligations under or related to Purchase Orders or
                                  any acts or omissions by Members or Distributors; (iv) WHSCorp has no
                                  control over Distributors, the content and data provided to it by the
                                  Distributors, or over the products or goods delivered by Distributors; (v)
                                  WHSCorp makes no representations as to the reliability, capability, or
                                  qualifications of any Distributor, the quality, security or legality of any
                                  products or goods or the accuracy and completeness of the information
                                  provided by any Distributor and WHSCorp disclaims any and all liability
                                  relating thereto; and, (vi) the Member has alternative means and procedures
                                  to order product from the Distributors during times when access to the
                                  WHSCorp Platform is unavailable.
                              </p>
                              <p>
                                  <strong>5.2 Incentives</strong>
                              </p>
                              <p>
                                  Members expressly acknowledge, agree and understand that WHSCorp may
                                  receive incentives from Distributors and manufacturers based on the overall
                                  purchases of Members (the “Cash Back”). WHSCorp will distribute to WHSCorp
                                  Elite Members and Pro Members (as such terms are defined below) a portion
                                  of the Cash Back; being an amount equal to the Cash Back net of any
                                  management fees (such management fees shall be determined exclusively by
                                  WHSCorp). Cash Back payments shall be paidannually in instalments within
                                  ninety (90) days after they are received and verified by WHSCorp. Cash Back
                                  payments will only be made after WHSCorp receives all required information
                                  from the Distributors. The parties agree to reconcile and adjust any
                                  discrepancies in Cash Back received, credited or allocated to WHSCorp by
                                  Distributors and in the event that WHSCorp, following its fiscal year end,
                                  determines that there was either an overpayment or underpayment of Cash
                                  Back to the WHSCorp Elite Member or Pro Member, then the parties shall make
                                  such adjustments as are necessary within thirty (30) days of being notified
                                  by WHSCorp. Cash Back payment will only be made to a WHSCorp Elite Member
                                  or Pro Member whose account is in good standing.
                              </p>
                              <p>
                                  <strong>5.3 Proprietary Rights</strong>
                              </p>
                              <p>
                                  WHSCorp and its licensors reserve all Proprietary Rights (as defined below)
                                  in and to the WHSCorp Platform and WHSCorp. Members and Distributors may
                                  not use the WHSCorp Platform except as necessary for the purposes of
                                  discharging its obligations under this Agreement and any Service Contract
                                  entered into pursuant to this Agreement and on the terms set out in the
                                  Service Contract (as defined below). WHSCorp reserves the right to
                                  withdraw, expand and otherwise change the WHSCorp Platform at any time in
                                  WHSCorp’s sole discretion. Members and Distributors shall not be entitled
                                  to create any “links” to the WHSCorp Platform, or “frame” or “mirror” any
                                  content contained on, or accessible through, the WHSCorp Platform, on any
                                  other server or internet-based device. WHSCorp alone (and its licensors,
                                  where applicable) shall own all right, title and interest, including all
                                  related Proprietary Rights, in and to any suggestions, ideas, enhancement
                                  requests, feedback, recommendations or other information provided by you or
                                  any other party relating to the WHSCorp Platform and WHSCorp. This
                                  Agreement does not constitute a sale and does not convey to you any rights
                                  of ownership in or related to the WHSCorp Platform and WHSCorp, or any
                                  Proprietary Rights owned by WHSCorp. WHSCorp’s name, logo, and the product
                                  names associated with WHSCorp or the WHSCorp Platform are trademarks of
                                  WHSCorp or third parties, and no right or license is granted to use them.
                              </p>
                              <p>
                                  <strong>6. Enforcement of Member Agreement and Policies</strong>
                              </p>
                              <p>
                                  WHSCorp has the right, but not the obligation, to suspend or cancel your
                                  access to the WHSCorp Platform if it believes that you have violated or
                                  acted inconsistently with the letter or spirit of this Agreement or
                                  violated our rights or those of another party. Without limiting WHSCorp’s
                                  other remedies, we may suspend or terminate your account and refuse to
                                  provide any further access to the WHSCorp Platform to you if: (i) you
                                  breach any terms and conditions of this Agreement or other written policies
                                  and procedures posted on the Site; (ii) we are unable to verify or
                                  authenticate any information you provide to us; or (iii) we believe that
                                  your actions may cause legal liability for you, other Members, Distributors
                                  or for WHSCorp. Once suspended or terminated, you MAY NOT continue to use
                                  the WHSCorp Platform under a different account or reregister under a new
                                  account. Violations of this Agreement may be prosecuted to the fullest
                                  extent of the law and may result in additional penalties and sanctions.
                                  When your Member account is cancelled, you may no longer have access to any
                                  parts of the WHSCorp Platform, including data, files and other material you
                                  have stored on WHSCorp Platform or with WHSCorp.
                              </p>
                              <p>
                                  <strong>7. Confidential Information</strong>
                              </p>
                              <p>
                                  To the extent a Member, a Distributor or WHSCorp provides Confidential
                                  Information (as defined below) to one or the other, the recipient shall
                                  protect the secrecy of the Confidential Information with the same degree of
                                  care as it uses to protect its own confidential information, but in no
                                  event with less than due care, and shall not: (i) disclose Confidential
                                  Information to anyone except, in the case of WHSCorp, to any Member or
                                  Distributor engaged in a Service Contract; and (ii) use the Confidential
                                  Information, except as necessary for the performance of the Services for
                                  the relevant Purchase Order (including, without limitation, the storage or
                                  transmission of Confidential Information on or through WHSCorp Platform for
                                  use by Distributor).
                              </p>
                              <p>
                                  <strong>8. Warranty Disclaimer</strong>
                              </p>
                              <p>
                                  NOTWITHSTANDING ANYTHING ELSE STATED ON THE WHSCORP PLATFORM (INCLUDING
                                  WITHOUT LIMITATION ON THE SITE) OR BY ANY OF WHSCORP’S REPRESENTATIVES,
                                  WHSCORP MAKES NO REPRESENTATION, WARRANTY, OR GUARANTY AS TO THE
                                  RELIABILITY, TIMELINESS, QUALITY, SUITABILITY, AVAILABILITY, SAFETY,
                                  ACCURACY OR COMPLETENESS OF THE SERVICES, WHSCORP PLATFORM, QUALITY OR
                                  CAPACITY OF THE MEMBER OR DISTRIBUTOR, OR ANY PRODUCTS, ITEMS OR ACTIVITIES
                                  RELATING TO THIS AGREEMENT (COLLECTIVELY THE “DISCLAIMED ITEMS”). WHSCORP
                                  DOES NOT REPRESENT OR WARRANT THAT (i) THE USE OF THE WHSCORP PLATFORM WILL
                                  BE SECURE, TIMELY, UNINTERRUPTED OR ERROR-FREE OR OPERATE IN COMBINATION
                                  WITH ANY OTHER HARDWARE, APPLICATION, SYSTEM OR DATA, (ii) THE DISCLAIMED
                                  ITEMS WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS, (iii) ANY STORED DATA
                                  WILL BE ACCURATE OR RELIABLE, (iv) THE QUALITY OF THE DISCLOSED ITEMS, AS
                                  WELL AS ANY PRODUCTS, SERVICES, INFORMATION, OR OTHER MATERIAL PURCHASED OR
                                  OBTAINED BY YOU THROUGH THE WHSCORP PLATFORM WILL MEET YOUR REQUIREMENTS OR
                                  EXPECTATIONS, (v) ERRORS OR DEFECTS IN THE DISCLAIMED ITEMS WILL BE
                                  CORRECTED, OR (vi) THE WHSCORP PLATFORM IS FREE OF VIRUSES OR OTHER HARMFUL
                                  COMPONENTS. THE DISCLAIMED ITEMS ARE PROVIDED TO YOU STRICTLY ON AN “AS IS”
                                  BASIS. ALL CONDITIONS, REPRESENTATIONS AND WARRANTIES, WHETHER EXPRESS,
                                  IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED
                                  WARRANTY OR CONDITION OF MERCHANTABILITY AND MERCHANTABLE QUALITY, FITNESS
                                  FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT OF THIRD PARTY RIGHTS, ARE
                                  HEREBY DISCLAIMED TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW BY
                                  WHSCORP. WHSCORP MAKES NO REPRESENTATION, WARRANTY, OR GUARANTY AS TO THE
                                  RELIABILITY, SAFETY, TIMELINESS, QUALITY, SUITABILITY OR AVAILABILITY OF
                                  THE DISCLAIMED ITEMS, AS WELL AS ANY SERVICES, PRODUCTS OR GOODS OBTAINED
                                  FROM DISTRIBUTORS OR THIRD PARTIES THROUGH THE USE OF THE DISCLAIMED ITEMS.
                                  YOU ACKNOWLEDGE AND AGREE THAT THE ENTIRE RISK ARISING OUT OF THE
                                  DISCLAIMED ITEMS REMAINS SOLELY WITH YOU, TO THE MAXIMUM EXTENT PERMITTED
                                  BY LAW.WHSCORP’S PLATFORM MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER
                                  PROBLEMS INHERENT IN THE USE OF THE INTERNET AND ELECTRONIC COMMUNICATIONS.
                                  WHSCORP IS NOT RESPONSIBLE FOR ANY DELAYS, DELIVERY FAILURES, OR OTHER
                                  DAMAGES OF WHATSOEVER NATURE RESULTING FROM SUCH PROBLEMS.
                              </p>
                              <p>
                                  <strong>9. Limitation of Liability</strong>
                              </p>
                              <p>
                                  IN NO EVENT SHALL WHSCORP’S AGGREGATE LIABILITY EXCEED CDN $2,500. IN NO
                                  EVENT SHALL WHSCORP BE LIABLE TO ANYONE FOR ANY INDIRECT, PUNITIVE,
                                  SPECIAL, EXEMPLARY, INCIDENTAL, CONSEQUENTIAL OR OTHER DAMAGES OF ANY TYPE
                                  OR KIND (INCLUDING PERSONAL INJURY, LOSS OF DATA, REVENUE, PROFITS, USE OR
                                  OTHER ECONOMIC ADVANTAGE). WHSCORP SHALL NOT BE LIABLE FOR ANY LOSS, DAMAGE
                                  OR INJURY WHICH MAY BE INCURRED BY YOU, INCLUDING BUT NOT LIMITED TO LOSS,
                                  DAMAGE OR INJURY ARISING OUT OF, OR IN ANY WAY CONNECTED WITH THE
                                  DISCLAIMED ITEMS, INCLUDING BUT NOT LIMITED TO THE USE OR INABILITY TO USE
                                  THE WHSCORP PLATFORM OR AS TO THE QUALITY OR CAPACITY OF THE MEMBER OR
                                  DISTRIBUTOR, ANY RELIANCE PLACED BY YOU ON THE COMPLETENESS, ACCURACY OR
                                  EXISTENCE OF ANY ADVERTISING, OR AS A RESULT OF ANY RELATIONSHIP OR
                                  TRANSACTION BETWEEN YOU AND ANY THIRD PARTY SERVICE PROVIDER, ADVERTISER OR
                                  SPONSOR WHOSE ADVERTISING APPEARS ON THE WHSCORP PLATFORM OR IS REFERRED BY
                                  WHSCORP OR THE WHSCORP PLATFORM, EVEN IF WHSCORP HAVE BEEN PREVIOUSLY
                                  ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. RESPONSIBILITY FOR THE
                                  DECISIONS YOU MAKE REGARDING THE PRODUCTS OR ITEMS OFFERED VIA THE WHSCORP
                                  PLATFORM RESTS SOLELY WITH YOU. WE WILL NOT ASSESS THE SUITABILITY,
                                  LEGALITY OR ABILITY OF ANY SUCH MEMBER OR DISTRIBUTOR OR OTHER THIRD
                                  PARTIES AND YOU EXPRESSLY WAIVE AND RELEASE WHSCORP FROM ANY AND ALL
                                  LIABILITY, CLAIMS, CAUSES OF ACTION, OR DAMAGES ARISING FROM YOUR USE OF
                                  THE WHSCORP PLATFORM, OR IN ANY WAY RELATED TO THE MEMBER, DISTRIBUTOR OR
                                  THIRD PARTIES INTRODUCED TO YOU BY THE WHSCORP PLATFORM, OR WITH RESPECT TO
                                  THE PERFORMANCE OF ANY OBLIGATIONS WITH ANY MEMBER AND DISTRIBUTOR, AS WELL
                                  AS ALL LOSSES RELATING THERETO.
                              </p>
                              <p>
                                  <strong>10. Indemnification</strong>
                              </p>
                              <p>
                                  <strong>10.1 Proprietary Rights</strong>
                              </p>
                              <p>
                                  Each Member shall indemnify, defend and hold harmless WHSCorp and its
                                  subsidiaries and affiliates, and each of their shareholders, directors
                                  officers, agents, employees, representatives and agents (each an
                                  “Indemnified Party”, and collectively the “Indemnified Parties”)) from any
                                  and all claims, damages, liabilities, costs, and expenses (including, but
                                  not limited to, reasonable attorneys’ fees and all related costs and
                                  expenses) arising from or relating to any claim, judgment, or adjudication
                                  that any Purchase Order or action or omission by such Member or Distributor
                                  infringes Proprietary Rights or other rights of any third party.
                              </p>
                              <p>
                                  <strong>10.2 Indemnification by Member</strong>
                              </p>
                              <p>
                                  Each Member shall indemnify, defend and hold harmless the Indemnified
                                  Parties from any and all claims, damages, liabilities, costs, and expenses
                                  (including, but not limited to, reasonable attorneys’ fees and all related
                                  costs and expenses) arising from or relating to: (i) such Member’s use of
                                  Services, including without limitation claims by or on behalf of any
                                  Distributor; (ii) any Purchase Order entered into between such Member and a
                                  Distributor; or (iii) any breach of their obligations set forth herein.
                              </p>
                              <p>
                                  <strong>10.3 Extended Meaning</strong>
                              </p>
                              <p>
                                  Any indemnity in favour of WHSCorp, and any release of WHSCorp, shall also
                                  be construed as being an indemnity or release, as the case may be, of the
                                  Indemnified Parties.
                              </p>
                              <p>
                                  <strong>10.4 Dispute Resolution and Governing Law</strong>
                              </p>
                              <p>
                                  This Agreement and any action, dispute, controversy or claim related
                                  thereto will be governed by the laws of the Province of Quebec without
                                  regard to its conflict of laws provisions. The exclusive jurisdiction and
                                  venue of any action in relation to this Agreement will be the District of
                                  Montreal and each of the parties hereto waives any objection to
                                  jurisdiction and venue in such courts. However, in the event of the actual
                                  or threatened infringement, misappropriation or violation of WHSCorp’s
                                  Proprietary Rights, WHSCorp may, at its discretion, institute legal
                                  proceedings in any jurisdiction (s) which is (are) deemed necessary or
                                  advisable.
                              </p>
                              <p>
                                  <strong>10.5 Independent Legal Advice</strong>
                              </p>
                              <p>
                                  You acknowledge that WHSCorp is not providing any legal advice, and that
                                  you have been afforded an opportunity to obtain independent legal advice
                                  with respect to this Agreement, and that you understand the nature and the
                                  consequences of this Agreement.
                              </p>
                              <p>
                                  <strong>11. Term and Termination</strong>
                              </p>
                              <p>
                                  <strong>11.1 Term</strong>
                              </p>
                              <p>
                                  The term of this Agreement commences on the Effective Date and continues in
                                  effect until terminated in accordance with Section 11.2 below.
                              </p>
                              <p>
                                  <strong>11.2 Termination</strong>
                              </p>
                              <p>
                                  Either WHSCorp or a Member may terminate this Agreement at any time, with
                                  or without cause, effective immediately upon either (a) a Member closing
                                  its account by confirming same by clicking “Preferences” followed by “My
                                  Account” on the WHSCorp Platform and pressing the “Close Account” button or
                                  (b) WHSCorp sending you an email confirmation in accordance with Section
                                  12.3 below that it has terminated your Member account. However, any such
                                  termination for convenience shall not affect the validity of any Purchase
                                  Orders that have been executed prior to such termination and this Agreement
                                  shall continue to apply with respect to such Purchase Orders.
                              </p>
                              <p>
                                  <strong>11.3 Consequences of Termination</strong>
                              </p>
                              <p>
                                  All terms set forth herein which by their nature survive termination shall
                                  survive the termination of this Agreement, including, but not limited to,
                                  the provisions of Articles 7, 8, 9 and 10 (and any indemnity or release set
                                  forth elsewhere in this Agreement).
                              </p>
                              <p>
                                  <strong>12. All the Rest</strong>
                              </p>
                              <p>
                                  <strong>12.1 Entire Agreement</strong>
                              </p>
                              <p>
                                  This Agreement sets forth the entire agreement and understanding of the
                                  parties relating to its subject matter and cancels and supersedes any prior
                                  or contemporaneous discussions, agreements, representations, warranties,
                                  and other communications between them.
                              </p>
                              <p>
                                  <strong>12.2 Compliance</strong>
                              </p>
                              <p>
                                  Members shall not violate any laws or third party rights on or related to
                                  the WHSCorp Platform. Without limiting the generality of the foregoing,
                                  Members agree to comply with all applicable import and export control laws
                                  and third parties’ Proprietary Rights.
                              </p>
                              <p>
                                  <strong>12.3 Notices: Consent to Electronic Notice</strong>
                              </p>
                              <p>
                                  You consent to the use of (a) electronic means to complete this Agreement
                                  and to deliver any notices pursuant to this Agreement; and (b) electronic
                                  records to store information related to this Agreement or your use of the
                                  WHSCorp Platform. Notices hereunder shall be invalid unless made in writing
                                  and given (a) by WHSCorp via email (in each case to the address that you
                              provide), (b) a posting on the WHSCorp Site or (c) by you via email to    <a href="mailto:support@whscorp.com">support@whscorp.com</a>) or to such
                                  other addresses as WHSCorp may specify in writing. The date of receipt will
                                  be deemed the date on which such notice is transmitted.
                              </p>
                              <p>
                                  <strong>12.4 No Waiver</strong>
                              </p>
                              <p>
                                  The failure or delay of either party to exercise or enforce any right or
                                  claim does not constitute a waiver of such right or claim and shall in no
                                  way affect that party’s right to later enforce or exercise it, unless such
                                  party issues an express written waiver, signed by a duly authorized
                                  representative of each party.
                              </p>
                              <p>
                                  <strong>12.5 Assignability</strong>
                              </p>
                              <p>
                                  Members may not assign this Agreement, or any of its rights or obligations
                                  hereunder, without WHSCorp’s prior written consent in the form of a written
                                  instrument signed by a duly authorized representative of WHSCorp (and, for
                                  the purposes of this Section 12.5, a written instrument shall expressly
                                  exclude electronic communications such as email and electronic notices but
                                  shall include facsimiles). WHSCorp may freely assign this Agreement without
                                  the consent of is Members. Any attempted assignment or transfer in
                                  violation of this Section will be null and void. Subject to the foregoing
                                  restrictions, this Agreement will inure to the benefit of the successors
                                  and permitted assigns of the parties.
                              </p>
                              <p>
                                  <strong>12.6 Severability</strong>
                              </p>
                              <p>
                                  If and to the extent any provision of this Agreement is held illegal,
                                  invalid, or unenforceable in whole or in part under applicable law, such
                                  provision or such portion thereof shall be ineffective as to the
                                  jurisdiction in which it is illegal, invalid, or unenforceable to the
                                  extent of its illegality, invalidity, or unenforceability, and shall be
                                  deemed modified to the extent necessary to conform to applicable law so as
                                  to give the maximum effect to the intent of the parties. The illegality,
                                  invalidity, or unenforceability of such provision in that jurisdiction
                                  shall not in any way affect the legality, validity, or enforceability of
                                  such provision in any other jurisdiction or of any other provision in any
                                  jurisdiction.
                              </p>
                              <p>
                                  <strong>12.7. Language</strong>
                              </p>
                              <p>
                                  You have requested and agreed that this Agreement be drafted in English.
                                  <em>
                                      Vous avez demandé et accepté que cette convention soit rédigée en
                                      anglais
                                  </em>
                                  .
                              </p>
                              <p>
                                  <strong>13. Definitions</strong>
                              </p>
                              <p>
                                  “Confidential Information” means any information provided by us, a Member
                                  or a Distributor in relation to the WHSCorp Platform usage, regardless of
                                  whether in tangible, electronic, verbal, graphic, visual or other form.
                                  Confidential Information does not include material or information that:
                              </p>
                              <p>
                                  (a) is generally known by third parties as a result of no act or omission
                                  of a party;
                              </p>
                              <p>
                                  (b) was lawfully received without restriction on disclosure from a third
                                  party having the right to disseminate the information;
                              </p>
                              <p>
                                  (c) was already known by a party prior to receiving it from the other party
                                  and was not received from a third party in breach of that third party's
                                  obligations of confidentiality; or
                              </p>
                              <p>
                                  (d) was independently developed by a party without use of Confidential
                                  Information.
                              </p>
                              <p>
                                  “Effective Date” means the date of acceptance of this Agreement.
                              </p>
                              <p>
                                  “Distributor" means trading partner, namely a distributor or a manufacturer
                                  of information technology hardware with which you already have a separate
                                  agreement that entitles you to conduct business with and for which WHSCorp
                                  provides the Services.
                              </p>
                              <p>
                                  “Elite Member” means a Member who selects the “Elite Member” plan in its
                                  subscription profile and has paid the corresponding monthly membership
                                  fees.
                              </p>
                              <p>
                                  “Member” means any person having an account on the WHSCorp Platform.
                              </p>
                              <p>
                                  “Pro Member” means a Member who selects the “Pro Member” plan in its
                                  subscription profile and has paid the corresponding monthly membership
                                  fees.
                              </p>
                              <p>
                                  “Proprietary Rights” means any and all rights, title, ownership and
                                  interest in and to copyrights, mask works, industrial designs, trademarks,
                                  service marks, trade names, trade secrets, patents, and any other rights to
                                  intellectual property, recognized in any jurisdiction, whether or not
                                  perfected.
                              </p>
                              <p>
                                  “Purchase Order” means a purchase order made by a Member to one of its
                                  Distributors through the WHSCorp Platform.
                              </p>
                              <p>
                                  “Service Contract” means, following the rendering of the Services, an
                                  agreement between a Member and a Distributor setting forth the terms of
                                  their agreement in respect of the purchase and sale of information
                                  technology hardware.
                              </p>
                              <p>
                                  “Services” means the online services offered by WHSCorp through the WHSCorp
                                  Platform through the various programs described at
                                  https://www.whscorp.com/registration_plans_01.aspx.
                              </p>
                              <p>
                                  If you have any questions or comments concerning these Terms and Conditions
                              you can always contact us at    <a href="mailto:support@whscorp.com">support@whscorp.com</a>)
                              </p>
                              <p>
                                  <strong><u>SECTION 2:</u></strong>
                              </p>
                              <p>
                                  <strong>
                                      CHANNEL PARTNER ALLIANCE TERMS &amp; CONDITIONS FOR ELITE 300
                                      MASTERMIND MEMBERSHIP PROGRAM AS OF NOVEMBER 2018
                                  </strong>
                              </p>
                              <p>
                                  The following are the terms and conditions for the Elite 300 Mastermind
                                  Program as part of the benefits of the Channel Partner Alliance Membership
                                  as of November 2018. By subscribing to the membership, you are agreeing to
                                  these terms and conditions.
                              </p>
                              <p>
                                  <strong>Elite 300 Mastermind Standard Program includes:</strong>
                              </p>
                              <p>
                                  1 Face-to-Face (2-day) event per 12-month period (attend any of the 3
                                  regional events)
                              </p>
                              <p>
                                  2 Mastermind sessions during the live event
                              </p>
                              <p>
                                  1-Night hotel accommodation during event All scheduled meals and drinks
                                  during official event activities
                              </p>
                              <p>
                                  12 Virtual Masterclasses per 12-month period Access to our resources to
                                  find tools to run your business efficiently
                              </p>
                              <p>
                                  Special discounts to featured tools and services
                              </p>
                              <p>
                                  To review a complete list of all services included in this Membership,
                              visit website    <a href="http://www.elite300mastermind.com/">www.elite300mastermind.com</a>
                                  under “Memberships” tab. Only the Standard Membership is included in this
                                  initial phase.
                              </p>
                              <p>
                                  Members may be upgraded automatically to higher membership levels based on
                                  the actual amount of Marketing Development Funds (MDF) collected on their
                                  behalf over the duration of each one year period. Membership may be
                                  terminated without notice if MDF collected do not cover the listed cost of
                                  the membership fees.
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong>
                                      Authorization to claim, collect and use Marketing Development Funds
                                      (MDF):
                                  </strong>
                              </p>
                              <p>
                                  The Channel Partner Alliance program is about negotiating MDF from various
                                  suppliers to help its members pay for their fees as well as related
                                  services. Upon signing up for this program, you are agreeing to allow WHS
                                  and TechnoPlanet under the Channel Partner Alliance program (collectively
                                  referred to as “Company”) to request and claim MDF from all distributors,
                                  vendors and other suppliers that are part of the program and use said funds
                                  to subsidize all costs associated with the services that we deliver to you.
                                  You also agree to inform suppliers, if they contact you, that you have
                                  authorized The Channel Partner Alliance to claim MDF funds to subsidize
                                  your membership costs. Alternatively, we can supply an authorization letter
                                  that you can sign for us to show suppliers upon request.
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong>Duration</strong>
                              </p>
                              <p>
                                  Program shall be for twelve (12) months in length (herein referred to as
                                  “Membership Period”). Member understands all benefits shall automatically
                                  renew at the end of the membership period, but unused services or MDF, if
                                  any, will not be carried-over to subsequent membership periods. All of
                                  Member’s benefits must be used during the commitment period.
                              </p>
                              <p>
                                  <strong>Method of Payment, if any</strong>
                              </p>
                              <p>
                                  If member subscribes to higher membership levels or additional services
                                  without MDF funding, then member shall pay for those membership dues and
                                  services through MasterCard, Visa or American Express (with payment to be
                                  processed through PayPal). Post dated checks are also acceptable. 5%
                                  discount available for prepayment of annual Membership fees in full, if
                                  any.
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong>Refund Policy on funds collected</strong>
                              </p>
                              <p>
                                  No refunds will be issued and transfers are not available.
                              </p>
                              <p>
                                  <strong>Confidentiality</strong>
                              </p>
                              <p>
                                  The Company respects the Member’s privacy and insists that the Member
                                  respects the Company’s and the other Member’s and all Event Participants
                                  (herein referred to as “Participants”). Thus, consider this a mutual
                                  non-disclosure agreement. Any Confidential Information shared by the
                                  Company, any representative of the Company, or the Participants is
                                  confidential, proprietary, and belongs solely and exclusively to the Party
                                  who discloses it. All Parties agree not to disclose, reveal or make use of
                                  any Confidential Information or any transactions, during discussions or
                                  otherwise.
                              </p>
                              <p>
                                  <strong>Airfare and Travel Arrangements</strong>
                              </p>
                              <p>
                                  Member is solely responsible for: (1) booking airfare and travel
                                  arrangements for the events dates; (2) securing all required travel
                                  documents and visas; (3) complying with all laws, regulations, orders,
                                  demands and requirements for each country the Member visits; and (4) fees
                                  or cost associated with delays, cancellations or changes in arrival or
                                  departure times for Member’s flights.
                              </p>
                              <p>
                                  <strong>No Transfer of Intellectual Property</strong>
                              </p>
                              <p>
                                  All intellectual property, including Company’s copyrighted events and/or
                                  program materials, shall remain the solely and exclusively the property of
                                  the Company. No license to sell, reproduce or distribute Company's
                                  materials is granted or implied. Member agrees not to infringe any
                                  copyright, patent, trademark, trade secret, or other intellectual property
                                  rights of the Company or Members or Participants.
                              </p>
                              <p>
                                  <strong> </strong>
                              </p>
                              <p>
                                  <strong>Member Responsibility and Results</strong>
                              </p>
                              <p>
                                  The Events and services are developed for strictly business educational
                                  purposes. Member accepts and agrees that Member is fully responsible for
                                  their progress and results from the Events and services, tools and all
                                  services offered. The Company makes no representations, warranties or
                                  guarantees verbally or in writing. Member understands that the results
                                  experienced by each Member may vary. Member acknowledges that as with any
                                  business endeavour, there is an inherent risk of loss of capital and there
                                  is no guarantee that Member will reach their goals as a result of
                                  participation in any activities of the program.
                              </p>
                              <p>
                                  <strong>Disclaimer</strong>
                              </p>
                              <p>
                                  Member acknowledges that neither the Company, their affiliates, nor any of
                                  their respective employees, agents, third parties, or licensors warrant
                                  that the services will be uninterrupted or error free; nor do they make any
                                  warranty as to the results that may be obtained from these Events and
                                  services as to the timeliness, sequence, accuracy, reliability,
                                  completeness, or content of any information or service provided through the
                                  Events and services.
                              </p>
                              <p>
                                  <strong>Changes in Terms and Conditions</strong>
                              </p>
                              <p>
                                  These terms and conditions are subject to change with 30 days notice.
                                  Please review to this same link of this page to view the up to date Terms
                                  and Conditions. Contact the Company for more information.
                              </p>
                              <p>
                                  Copyright TechnoPlanet Productions Inc. All right reserved.
                              </p>
                              <p>
                                  <strong><u>SECTION 3:</u></strong>
                              </p>
                              <p>
                                  <strong><u>JOINT TERMS AND CONDITIONS OF USE</u></strong>
                              </p>
                              <p>
                                  <a name="_Ref509394782">
                                      <strong>1. </strong>
                                      <strong><u>Accepting the Terms &amp; Conditions</u></strong>
                                  </a>
                                  <strong><u> of the Program</u></strong>
                                  <u></u>
                              </p>
                              <p>
                                  These Terms and Conditions of Use (the “<strong>Agreement</strong>”) is a
                                  contract between you (the “<strong>Member</strong>”), 8174563 Canada Inc, a
                                  Canadian incorporated entity (“<strong>WHS</strong>”), and TechnoPlanet
                              Productions, Inc., an Ontario incorporated company (“<strong>TechnoPlanet</strong>”, and together with WHS, the “    <strong>Service Providers</strong>”).
                              </p>
                              <p>
                                  WHS carries on the business of operating an online aggregator platform,
                                  that allows its members, namely information technology hardware resellers
                                  to research information technology product pricing and availability
                                  information from the websites of multiple information technology hardware
                                  distributors (the “<strong>WHS Platform</strong>”). TechnoPlanet carries on
                                  the business of operating an educational platform offering classes, events
                                  and online webinars dedicated to improving the profitability of information
                                  technology hardware resellers (the “<strong>TechnoPlanet Platform</strong>
                                  ”).
                              </p>
                              <p>
                                  The Service Providers wish to offer the Member a loyalty program designed
                                  for information technology hardware resellers offering access to both the
                                  WHS Platform (“Elite” program) and the TechnoPlanet Platform (“Standard”
                                  program) (the “<strong>Program</strong>”).
                              </p>
                              <p>
                                  The Member must read, agree with and accept all of the terms and conditions
                                  contained in this Agreement as well as those terms and conditions in
                                  respect of the WHS Platform
                                  <a href="https://www.whscorp.com/readterms.aspx?param=2">
                                      https://www.whscorp.com/readterms.aspx?param=2
                                  </a>
                                  (the “<strong>WHSCorp Terms and Conditions</strong>”) and the TechnoPlanet
                                  Platform
                                  <a href="http://technoplanet.com/300Elite/Terms.pdf">
                                      http://technoplanet.com/300Elite/Terms.pdf
                                  </a>
                                  (the “<strong>Channel Partner Alliance Terms and Conditions</strong>” and
                              together with the WHSCorp Terms and Conditions, the “    <strong>Service Providers’ Terms of Use</strong>”) in order to enroll in
                                  the Program and the related software and services.
                              </p>
                              <p>
                                  For greater clarity, all Members who have enrolled in the Program by
                                  clicking “Join Now” on the “Registration” webpage on the WHS Platform (
                                  <a href="https://www.whscorp.com/registration_plans_01.aspx">
                                      https://www.whscorp.com/registration_plans_01.aspx
                                  </a>
                                  ) agree that their enrollment in the Program shall be governed by the terms
                                  of this Agreement, the WHSCorp Terms and Conditions and the Channel Partner
                                  Alliance Terms and Conditions.
                              </p>
                              <p>
                                  <strong>2. </strong>
                                  <strong><u>Termination</u></strong>
                              </p>
                              <p>
                                  A Member, WHS or TechnoPlanet may terminate this Agreement at any time,
                                  with or without cause, effective immediately upon either (a) a Member
                                  closing its account on the WHS Platform pursuant to Section 11.2 of the
                                  WHSCorp Terms and Conditions or a Member closing its account on the
                                  TechnoPlanet Platform by clicking “Preferences” followed by “My Account” on
                                  the WHS Platform and opting out of the right to access the TechnoPlanet
                                  Platform by finally clicking “WHS without Education”, (b) WHS terminating a
                                  Member’s account on the WHS Platform in accordance with Section 11.2 of the
                                  WHSCorp Terms and Conditions or (c) TechnoPlanet terminating a Member’s
                                  account on the TechnoPlanet Platform by sending such Member an email to
                                  that effect.
                              </p>
                              <p>
                                  Any termination made pursuant to clauses (a), (b) or (c) shall have the
                                  effect of terminating the Member’s enrollment in the Program. WHS and
                                  TechnoPlanet each have the right, at their complete respective discretion,
                                  to terminate this Agreement, and the terms of the WHSCorp Terms and
                                  Conditions or the Channel Partner Alliance Terms and Conditions,
                                  respectively, in respect of any Member and terminate such Member’s
                                  enrollment in the Program (the Service Provider who terminates the Member’s
                              enrollment in the Program is hereinafter referred to as the “    <strong>Terminating Service Provider</strong>”). However, the termination
                                  of this Agreement and the WHSCorp Terms and Conditions or the Channel
                                  Partner Alliance Terms and Conditions, as the case may be, by the
                                  Terminating Service Provider, and the ensuing termination of a Member’s
                                  enrollment in the Program shall only preclude such Member from continuing
                                  to access the platform of the Terminating Service Provider and from
                                  receiving the services of the Terminating Service Provider. For greater
                                  clarity, and by way of example, the termination of this Agreement and the
                                  Channel Partner Alliance Terms and Conditions by TechnoPlanet in respect of
                                  a given Member shall not have the result of terminating the WHSCorp Terms
                                  and Conditions in respect of such Member.
                              </p>
                              <p>
                                  <strong>3. </strong>
                                  <strong>
                                      <u>
                                          Relationship between the Member, WHS and TechnoPlanet and Liability
                                      </u>
                                  </strong>
                              </p>
                              <p>
                                  No joint venture, partnership, employment, solidary or agency relationship
                                  exists between the Member, TechnoPlanet, WHS or any third party as a result
                                  of this Agreement or enrollment in the Program. The Member acknowledges
                                  that he, she or it has agreed to the distinct and separate terms of use of
                                  each of the respective Service Providers, namely the WHSCorp Terms and
                                  Conditions and the Channel Partner Alliance Terms and Conditions. The
                                  rights, interests and obligations set forth in each of the distinct Service
                                  Providers’ Terms of Use shall be interpreted as being binding rights,
                                  interests and obligations exclusively between the Member and the individual
                                  Service Provider who is party to such agreement, unless otherwise expressly
                                  set forth in the Service Providers’ Terms of Use. As such, any and all
                                  liability incurred by a Service Provider that may arise out of or relating
                                  to a Service Providers’ Terms of Use shall relate solely to such individual
                                  Service Provider, and under no circumstances shall any liability be
                                  attributed to the other Service Provider. For greater certainty, (a) WHS
                                  shall not be responsible for any liability resulting from a breach of the
                                  obligations of TechnoPlanet pursuant to the Channel Partner Alliance Terms
                                  and Conditions and (b) TechnoPlanet shall not be responsible for any
                                  liability resulting from a breach of the obligations of WHS pursuant to the
                                  WHSCorp Terms and Conditions.
                              </p>
                              <p>
                                  <strong>4. </strong>
                                  <strong><u>General</u></strong>
                              </p>
                              <p>
                                  If any provision of this Agreement is held to be invalid or unenforceable,
                                  such provision shall be struck and the remaining provisions shall be
                                  enforced to the fullest extent under law. The failure of a Service Provider
                                  to enforce any right or provision in this Agreement shall not constitute a
                                  waiver of such right or provision unless acknowledged and agreed to by the
                                  Service Providers in writing. This Agreement as well as the WHSCorp Terms
                                  and Conditions and the Channel Partner Alliance Terms and Conditions
                                  comprise the entire agreement between the Member, WHS and TechnoPlanet and
                                  supersedes all prior or contemporaneous negotiations, discussions or
                                  agreements, whether written or oral, between the parties regarding the
                                  subject matter contained herein.
                              </p>
                              <p>
                                  You have requested and agreed that this Agreement be drafted in English.
                                  <em>
                                      Vous avez demandé et accepté que cette convention soit rédigée en
                                      anglais
                                  </em>
                                  .
                              </p>
                              <p>
                                  Should you have any questions or comments concerning this Agreement, please
                                  do not hesitate to contact us at tony@whscorp.com.
                              </p>
                              <br clear="all"/>
                              <div>
                                  <p>
                                      ###################1######################################
                                  </p>
                                  <p>
                                      Les membres du Programme WHS Elite comprenant les événements
                                      Elite300Mastermind et Channel Next) également connu sous le nom de
                                      Channel Partner Alliance doivent lire et accepter les sections
                              suivantes : Section (1) «        <strong>Conditions générales de WHSCorp </strong>», Section (2) «
                                      <strong>
                                          MODALITÉS DU PROGRAMME ELITE 300 MASTERMIND DANS LE CADRE DE LA
                                          CHANNEL PARTNER ALLIANCE – NOVEMBRE 2018
                                      </strong>
                                      » et Section (3) « <strong>CONDITIONS D’UTILISATION CONJOINTES</strong>
                                      ».
                                  </p>
                                  <p>
                                      <br/>
                                      Les membres du programme WHS PRO doivent lire et accepter la section
                                      suivante : Section (1) « Conditions générales WHSCorp »
                                      <br/>
                                      <br/>
                                      Les membres du programme WHS SOLO doivent lire et accepter la section
                              suivante : Section (1) « Conditions générales WHSCorp »        <strong></strong>
                                  </p>
                                  <p>
                                      <strong><u>SECTION 1 :</u></strong>
                                  </p>
                                  <p>
                                      <strong>Conditions générales de WHSCorp</strong>
                                  </p>
                                  <p>
                                      <strong>1. Acceptation des modalités de WHSCorp</strong>
                                  </p>
                                  <p>
                                      La présente entente d’adhésion du membre (l’« entente ») est un contrat
                                      entre vous (le « membre ») et 8174563 Canada Inc., une société
                                      constituée en vertu des lois du Canada (« WHSCorp » ou « nous »). Vous
                                      devez lire et accepter toutes les modalités figurant dans la présente
                              entente afin d’utiliser notre site Web accessible à        <a href="http://www.whscorp.com/">www.whscorp.com</a> (le « site »),
                                      ainsi que les logiciels et les services connexes (collectivement, avec
                                      le site, la « plateforme de WHSCorp »).
                                  </p>
                                  <p>
                                      WHSCorp peut modifier, supprimer ou ajouter des éléments à la présente
                                      entente (les « changements ») en tout temps. Les changements entreront
                                      en vigueur : i) trente (30) jours après la remise d’un avis relatif aux
                                      changements par WHSCorp, qu’il soit fourni au moyen de l’interface
                                      utilisateur du site ou envoyé à l'adresse de courriel associée au
                                      compte ou autrement ou ii) lorsque vous acceptez les changements ou une
                                      version de la présente entente qui intègre les changements, selon la
                              première éventualité, ou en convenez expressément d’une autre manière.        <strong></strong>
                                  </p>
                                  <p>
                                      Votre accès à la plateforme de WHSCorp et l’utilisation que vous en
                                      faites sont aussi régis par les renseignements, les directives et les
                                      politiques se trouvant sur le site, y compris, sans s’y limiter, la
                                      politique de protection des renseignements personnels pouvant être
                              consultée à        <a href="http://www.whscorp.com/privacy">www.whscorp.com/privacy</a>
                                      .S’il existe une incompatibilité entre les modalités de la présente
                                      entente et le site, les modalités de la présente entente ont préséance.
                                  </p>
                                  <p>
                                      VOUS COMPRENEZ QU’EN UTILISANT LA PLATEFORME DE WHSCORP, VOUS ACCEPTEZ
                                      D’ÊTRE LIÉ PAR LA PRÉSENTE ENTENTE. SI VOUS N'ACCEPTEZ PAS
                                      L’INTÉGRALITÉ DE LA PRÉSENTE ENTENTE, VOUS NE POUVEZ PAS ACCÉDER À LA
                                      PLATEFORME DE WHSCORP NI L’UTILISER. SI VOUS ACCEPTEZ LA PRÉSENTE
                                      ENTENTE AU NOM D’UNE ENTITÉ, VOUS DÉCLAREZ ET GARANTISSEZ QUE VOUS AVEZ
                                      LE POUVOIR DE LIER CETTE ENTITÉ À LA PRÉSENTE ENTENTE. LES TERMES «
                                      MEMBRE », « VOUS », « VOS » ET « VOTRE » DÉSIGNENT CETTE ENTITÉ.
                                  </p>
                                  <p>
                                      VOUS DÉCLAREZ ET GARANTISSEZ QUE VOUS N’ÊTES PAS UN CONSOMMATEUR
                                      CONFORMÉMENT À LA DÉFINITION FIGURANT DANS TOUTE LOI CANADIENNE
                                      APPLICABLE OU TOUTE AUTRE LOI APPLICABLE DE LA NATION, DU PAYS, DE
                                      L'ÉTAT, DE LA PROVINCE OU DE LA VILLE OÙ VOUS VOUS TROUVEZ LORSQUE VOUS
                                      UTILISEZ LA PLATEFORME DE WHSCORP.
                                  </p>
                                  <p>
                                      VOUS DÉCLAREZ ET GARANTISSEZ QUE LA PRÉSENTE ENTENTE N’ENTRAVE OU NE
                                      MODIFIE PAS TOUT CONTRAT DE VENTE QUE VOUS AVEZ CONCLU AVEC CHACUN DE
                                      VOS DISTRIBUTEURS OU AVEC DES TIERS.
                                  </p>
                                  <p>
                                      <strong>2. La plateforme de WHSCorp</strong>
                                  </p>
                                  <p>
                                      WHSCorp a créé un agrégateur en ligne, la « plateforme de WHSCorp »,
                                      qui permet au membre : a) de rechercher des renseignements sur le prix
                                      et la disponibilité d’un produit sur les sites Web de plusieurs
                                      distributeurs (définis ci-dessous) auprès desquels il détient un compte
                                      actif et b) d’envoyer un bon de commande (défini ci-dessous) concernant
                                      le produit choisi au distributeur. Le contrat d'achat se forme
                                      directement entre le membre et le distributeur. Nous ne sommes pas une
                                      partie à ce contrat.
                                  </p>
                                  <p>
                                      <strong>3. Pour commencer</strong>
                                  </p>
                                  <p>
                                      <strong>3.1 Admissibilité</strong>
                                  </p>
                                  <p>
                                      La plateforme de WHSCorp est accessible à toutes les entités juridiques
                                      capables de former des contrats juridiquement contraignants en vertu
                                      des lois applicables, à l'exclusion des consommateurs, tels qu’ils sont
                                      définis dans une loi, un décret, un règlement, un traité ou un acte
                                      d'administration qui s'applique à vous.
                                  </p>
                                  <p>
                                      Le membre convient qu’il n’est pas : a) un citoyen ou un résident d’un
                                      pays où l’utilisation ou la participation en question est interdite par
                                      une loi, un décret, un règlement, un traité ou un acte
                                      d'administration, b) un citoyen ou un résident d’un pays ou d’une
                                      région faisant l’objet de sanctions ou d’embargos des États-Unis ou
                                      d’un autre pays souverain, ni qu’il se trouve dans un tel pays ou une
                                      telle région, ou c) un employé ou une personne associée à une entité,
                                      ou encore une personne, qui figure sur la liste des personnes et
                                      entités refusées du département du Commerce des États-Unis, la liste
                                      des ressortissants expressément désignés ou des personnes bloquées par
                                      le département du Trésor des États-Unis ou la liste des parties
                                      interdites du département d’État, ou qui par ailleurs ne peut pas
                                      recevoir des articles assujettis aux lois et aux règlements sur le
                                      contrôle des exportations du Canada ou des États-Unis ou à d'autres
                                      règles sur les sanctions économiques de toute nation souveraine.
                                  </p>
                                  <p>
                                      <strong>3.2 Attentes</strong>
                                  </p>
                                  <p>
                                      WHSCorp s'attend à ce que tous ses membres fassent constamment preuve
                                      d’un degré élevé de courtoisie, de respect et de professionnalisme
                                      entre eux et envers nous et les distributeurs. Les membres conviennent
                                      de faire preuve de jugement lorsqu’ils publient des renseignements, des
                                      commentaires ou d'autres contenus se rapportant aux autres membres et
                                      aux distributeurs, à WHSCorp ou à un tiers figurant dans la plateforme
                                      de WHSCorp. Les membres peuvent être tenus responsables en droit des
                                      dommages subis par les autres membres et les distributeurs, WHSCorp ou
                                      un tiers en raison de commentaires, de remarques ou d'autres
                                      renseignements ou contenus publiés sur la plateforme de WHSCorp qui
                                      sont diffamatoires ou qui peuvent donner lieu à des poursuites
                                      juridiques. Tous les membres doivent se conformer à l’ensemble des lois
                                      qui s'appliquent à eux ou à leurs activités, ainsi qu’à toutes les
                                      politiques publiées par WHSCorp, qui sont intégrées par renvoi à la
                                      présente entente. Ces politiques peuvent être modifiées de temps à
                                      autre, à la discrétion de WHSCorp. Les politiques en vigueur sont
                                      réputées faire partie de la présente entente.
                                  </p>
                                  <p>
                                      Lorsque vous utilisez la plateforme de WHSCorp, vous convenez d'éviter
                                      de publier ou encore de transmettre, à destination ou en provenance de
                                      la plateforme de WHSCorp :
                                  </p>
                                  <p>
                                      i) du matériel ou du contenu illégal, haineux, raciste, menaçant,
                                      diffamatoire, obscène, pornographique ou autre qui violerait un droit à
                                      l’image ou à la vie privée, ou encore une loi;
                                  </p>
                                  <p>
                                      ii) du matériel ou du contenu qui viole ou détourne les droits d’un
                                      tiers, y compris, sans s’y limiter, un droit d’auteur, une marque de
                                      commerce, un brevet ou un autre droit de propriété d’un tiers;
                                  </p>
                                  <p>
                                      iii) des mensonges ou de faux renseignements qui pourraient nuire à
                                      nous-mêmes, à nos utilisateurs ou à un tiers;
                                  </p>
                                  <p>
                                      iv) des renseignements privés concernant une autre personne, sans leur
                                      permission;
                                  </p>
                                  <p>
                                      v) tout élément qui imite une autre personne ou qui vous représente
                                      comme étant affilié avec nous, nos employés ou d’autres professionnels
                                      de l’industrie;
                                  </p>
                                  <p>
                                      vi) tout élément qui sollicite le mot de passe ou d'autres
                                      renseignements sur le compte d’un utilisateur;
                                  </p>
                                  <p>
                                      vii) tout élément qui exploite les noms d’utilisateur, le adresses ou
                                      les adresses de courriel à toute fin;
                                  </p>
                                  <p>
                                      viii) des virus ou d’autres directives informatiques ou moyens
                                      technologiques ayant pour but de perturber ou d’endommager les
                                      ordinateurs ou les systèmes connexes, ou encore de nuire à leur
                                      utilisation.
                                  </p>
                                  <p>
                                      Vous ne devez pas accéder (ni tenter d'accéder) à la plateforme de
                                      WHSCorp par tout moyen autre que l’interface fournie, ni utiliser les
                                      renseignements tirés de la plateforme de WHSCorp à des fins autres que
                                      celles pour lesquelles ils ont été mis à votre disposition. Vous ne
                                      devez pas participer à toute activité qui nuit au fonctionnement de la
                                      plateforme de WHSCorp ou qui le perturbe. Vous ne devez pas téléverser
                                      ou joindre un fichier invalide, malveillant ou inconnu. Vous ne devez
                                      pas insérer des liens externes qui risquent d’être malveillants ou qui
                                      vous sont inconnus, ou encore qui servent à offrir des biens ou des
                                      services.
                                  </p>
                                  <p>
                                      Par les présentes, vous convenez aussi d’utiliser la plateforme de
                                      WHSCorp à des fins légitimes uniquement et non dans le cadre
                                      d'activités immorales ou nuisibles. Vous convenez de vous abstenir de
                                      faire tout ce qui suit lorsque vous utilisez la plateforme de WHSCorp
                                      ou y accédez :
                                  </p>
                                  <p>
                                      i) tenter d'accéder à la plateforme de WHSCorp, d'effectuer une
                                      recherche sur cette plateforme ou de télécharger du contenu à partir de
                                      celle-ci en utilisant un moteur, un logiciel, un outil, un agent, un
                                      appareil ou un mécanisme (y compris les collecteurs, les robots, les
                                      robots d’indexation, les outils d’exploration de données ou les autres
                                      outils semblables) autre que les logiciels ou les agents de recherche
                                      fournis par nous ou les autres navigateurs Web de tiers accessibles au
                                      public;
                                  </p>
                                  <p>
                                      ii) consulter, trafiquer ou utiliser des zones non publiques de la
                                      plateforme de WHSCorp, nos systèmes informatiques ou les systèmes
                                      techniques de livraison de nos fournisseurs;
                                  </p>
                                  <p>
                                      iii) recueillir et utiliser des renseignements comme le nom
                                      d’utilisateur, le vrai nom et l’adresse de courriel d’autres
                                      utilisateurs au moyen de la plateforme de WHSCorp pour transmettre de
                                      la publicité non sollicitée, du courriel indésirable, des pourriels ou
                                      toute autre forme de sollicitation;
                                  </p>
                                  <p>
                                      iv) utiliser la plateforme de WHSCorp au profit d’un tiers ou à toute
                                      fin commerciale non envisagée par la présente entente;
                                  </p>
                                  <p>
                                      v) violer une loi ou un règlement applicable;
                                  </p>
                                  <p>
                                      vi) encourager ou aider toute autre personne à faire ce qui précède.
                                      Nous nous réservons le droit de mener des enquêtes et d'engager des
                                      poursuites à l'égard de la violation de toute disposition ci-dessus, de
                                      demander aux autorités chargées de l'application des lois d’engager des
                                      poursuites contre les utilisateurs qui violent la présente entente, ou
                                      encore de collaborer avec elles à ces poursuites.
                                  </p>
                                  <p>
                                      WHSCorp n’est pas responsable en droit des remarques, des
                                      renseignements ou des autres contenus publiés ou rendus accessibles sur
                                      la plateforme de WHSCorp par un membre, un distributeur ou un tiers,
                                      même si ces renseignements ou contenus sont diffamatoires ou peuvent
                                      par ailleurs donner lieu à des poursuites juridiques. WHSCorp n'est pas
                                      responsable en droit de toute issue négative de la relation entre les
                                      membres et les distributeurs. WHSCorp n’est pas responsable de
                                      l'exactitude ou de la fiabilité du contenu, n’en fait pas le suivi et
                                      ne le censure pas. Cependant, WHSCorp se réserve le droit de retirer ou
                                      de restreindre l'accès aux renseignements ou aux contenus publiés ou
                                      rendus accessibles sur la plateforme de WHSCorp si elle reçoit un tel
                                      ordre de la part d’une autorité gouvernementale ou si WHSCorp considère
                                      que ces renseignements ou contenus violent la présente entente ou sont
                                      illicites, immoraux ou nuisibles.
                                  </p>
                                  <p>
                                      <strong> </strong>
                                  </p>
                                  <p>
                                      <strong>3.3 Identité et sécurité des comptes</strong>
                                  </p>
                                  <p>
                                      Tous les renseignements sur l’identité associés au compte d’un membre
                                      doivent être véridiques et vérifiables. WHSCorp se réserve le droit de
                                      valider les renseignements d’un membre en tout temps, y compris, sans
                                      s’y limiter, dans des bases de données de tiers ou dans un ou plusieurs
                                      documents juridiques ou gouvernementaux officiels qui confirment
                                      l’identité du membre. Vous autorisez WHSCorp, directement ou par
                                      l’intermédiaire de tiers, à poser toutes les questions nécessaires pour
                                      valider votre identité et confirmer le propriétaire de votre adresse de
                                      courriel ou de vos instruments financiers. Tout défaut de fournir des
                                      renseignements à votre sujet et au sujet de votre entreprise sur
                                      demande constitue une violation de la présente entente.
                                  </p>
                                  <p>
                                      Chaque membre peut créer des sous-comptes destinés à ses employés (le «
                                      sous-compte »). Chaque sous-compte doit être utilisé par une seule
                                      personne. Il incombe uniquement au membre de préserver la
                                      confidentialité et la sécurité du mot de passe de son compte et des
                                      sous-comptes, s’il y a lieu. Les membres conviennent de ne pas
                                      divulguer ces mots de passe à un tiers et sont les seuls responsables
                                      de l’utilisation ou des mesures prises dans le cadre de l’utilisation
                                      de ces mots de passe sur la plateforme de WHSCorp. Vous devez aviser
                                      l'équipe de soutien de WHSCorp (
                                      <a
                                          href="https://whscorp.com/NRPortbl/SSDocs/RGREENBERG/support@whscorp.com"
                                      >
                                          <strong>support@whscorp.com</strong>
                                      </a>
                                      ) immédiatement si vous soupçonnez la perte ou le vol d’un mot de
                                      passe.
                                  </p>
                                  <p>
                                      En utilisant votre compte de membre, vous reconnaissez et convenez que
                                      les procédures relatives à la sécurité des comptes de WHSCorp sont
                                      commercialement raisonnables. Vous ne pouvez pas permettre à des tiers
                                      d’utiliser votre mot de passe pour prendre toute mesure, y compris,
                                      sans s’y limiter, afficher un poste, soumettre sa candidature à un
                                      poste, fournir des services ou vendre des biens au moyen de votre
                                      compte de membre.
                                  </p>
                                  <p>
                                      <strong>4. Travailler dans la plateforme de WHSCorp</strong>
                                  </p>
                                  <p>
                                      <strong>4.1 Recherche</strong>
                                  </p>
                                  <p>
                                      En ce qui concerne les données sur les prix et les stocks figurant sur
                                      la plateforme de WHSCorp, WHSCorp se fie uniquement aux données
                                      fournies par les distributeurs. Par conséquent, les données sur les
                                      prix et les stocks sont fournies à titre indicatif seulement, peuvent
                                      changer et doivent être confirmées. Chaque distributeur met des données
                                      particulières, notamment sur le membre, à la disposition de son
                                      partenaire commercial comme WHSCorp. WHSCorp achemine les données de la
                                      plateforme de WHSCorp au site Web du distributeur et vice versa au nom
                                      du membre et à la demande du membre afin de fournir les services
                                      (définis ci-dessous).
                                  </p>
                                  <p>
                                      Pour permettre à WHSCorp de fournir les services en vertu de la
                                      présente entente, le membre reconnaît qu’il est tenu de fournir à
                                      WHSCorp, en format XML, ses comptes d’utilisateur et ses mots de passe
                                      pour chacun de ses distributeurs qu’il souhaite utiliser sur la
                                      plateforme de WHSCorp.
                                  </p>
                                  <p>
                                      <strong>4.2 Bons de commande</strong>
                                  </p>
                                  <p>
                                      Toutes les modalités figurant dans l'entente que vous avez conclue avec
                                      le distributeur pertinent doivent être considérées comme les modalités
                                      qui s’appliquent au bon de commande créé sur la plateforme de WHSCorp.
                                      Il demeure entendu que WHSCorp n'est partie à aucun bon de commande.
                                      Cependant, les modalités de la présente entente ont préséance sur toute
                                      modalité figurant dans toute autre entente établie entre le membre et
                                      le distributeur qui vise à élargir les obligations ou à restreindre les
                                      droits de WHSCorp en vertu de la présente entente.
                                  </p>
                                  <p>
                                      <strong>5. Reconnaissance du rôle de WHSCorp par les membres</strong>
                                  </p>
                                  <p>
                                      <strong>5.1 Bon de commande</strong>
                                  </p>
                                  <p>
                                      Les membres reconnaissent, acceptent et comprennent expressément que :
                                      i) la plateforme de WHSCorp n'est qu’un lieu où les membres peuvent
                                      rechercher des produits et envoyer des bons de commande aux
                                      distributeurs; ii) WHSCorp n'est partie à aucun bon de commande entre
                                      les membres et les distributeurs; iii) WHSCorp n'assume aucune
                                      responsabilité ou obligation relative aux bons de commande ou aux
                                      actions ou omissions des membres ou des distributeurs; iv) WHSCorp
                                      n'exerce aucun contrôle sur les distributeurs, les contenus et les
                                      données que lui remettent les distributeurs, ni sur les produits ou les
                                      biens livrés par ceux-ci; v) WHSCorp ne fait aucune déclaration
                                      relativement à la fiabilité, à la capacité ou aux compétences des
                                      distributeurs, à la qualité, à la sécurité ou à la légalité des
                                      produits ou des biens, ou encore à l’exactitude et à l’exhaustivité des
                                      renseignements fournis par un distributeur, et WHSCorp décline toute
                                      responsabilité à cet égard; vi) le membre a d'autres moyens ou
                                      procédures en place pour commander des produits auprès des
                                      distributeurs lorsque la plateforme de WHSCorp est inaccessible.
                                  </p>
                                  <p>
                                      <strong>5.2 Primes incitatives</strong>
                                      <strong></strong>
                                  </p>
                                  <p>
                                      Les membres reconnaissent, acceptent et comprennent expressément que
                                      WHSCorp peut recevoir des primes incitatives de la part des
                                      distributeurs et des fabricants en fonction de l’ensemble des achats
                                      effectués par les membres (la « remise en argent »). WHSCorp
                                      distribuera une partie de la remise en argent aux membres Elite et aux
                                      membres Pro de WHSCorp (termes définis ci-dessous). Son montant devra
                                      correspondre à la remise en argent, moins les frais de gestion (ceux-ci
                                      étant établis exclusivement par WHSCorp). Les remises en argent seront
                                      payées annuellement par versements dans les quatre-vingt-dix (90) jours
                                      suivant leur réception et leur vérification par WHSCorp. Ces versements
                                      ne seront effectués qu’une fois que WHSCorp aura reçu tous les
                                      renseignements requis de la part des distributeurs. Les parties
                                      acceptent de rapprocher et d’ajuster tout écart dans les remises en
                                      argent reçues, créditées ou attribuées à WHSCorp par les distributeurs.
                                      Dans l’éventualité où, à la fin de son exercice financier, WHSCorp
                                      déterminait qu’il y a eu paiement en trop ou en moins de la remise en
                                      argent au membre Elite ou au membre Pro de WHSCorp, les parties devront
                                      apporter les ajustements nécessaires dans les trente (30) jours suivant
                                      un avis remis par WHSCorp. Les remises en argent ne seront accordées
                                      qu’aux membres Elite et aux membres Pro de WHSCorp dont le compte est
                                      en règle.
                                  </p>
                                  <p>
                                      <strong>5.3 Droits de propriété</strong>
                                  </p>
                                  <p>
                                      WHSCorp et ses concédants de licence se réservent tous les droits de
                                      propriété (définis ci-dessous) se rapportant à la plateforme de WHSCorp
                                      et à WHSCorp. Les membres et les distributeurs ne peuvent utiliser la
                                      plateforme de WHSCorp qu'aux fins de s’acquitter de leurs obligations
                                      en vertu de la présente entente et de tout contrat de services conclu
                                      en vertu de la présente entente et selon les modalités établies dans le
                                      contrat de services (défini ci-dessous). WHSCorp se réserve le droit de
                                      retirer, d’élargir ou par ailleurs de modifier la plateforme de WHSCorp
                                      en tout temps, à son entière discrétion. Les membres et les
                                      distributeurs n’ont pas le droit de créer des « liens » vers la
                                      plateforme de WHSCorp, ni d’« encadrer » ou d’« imiter » tout contenu
                                      accessible ou figurant sur la plateforme de WHSCorp ou tout autre
                                      serveur ou appareil sur Internet. Seule WHSCorp (et ses concédants de
                                      licence, s’il y a lieu) détient tous les droits, titres et intérêts, y
                                      compris tous les droits de propriété connexes, relatifs aux
                                      suggestions, aux idées, aux demandes d'amélioration, aux commentaires,
                                      aux recommandations ou aux autres renseignements fournis par vous ou
                                      par tout autre tiers relativement à la plateforme de WHSCorp et à
                                      WHSCorp. La présente entente ne constitue pas une vente et ne vous
                                      attribue aucun droit de propriété relatif à la plateforme de WHSCorp et
                                      à WHSCorp, ni aucun droit de propriété détenu par WHSCorp. Le nom et le
                                      logo de WHSCorp, ainsi que les noms de produits associés à WHSCorp ou à
                                      la plateforme de WHSCorp sont des marques de commerce de WHSCorp ou de
                                      tiers. Aucun droit ni aucune licence permettant de les utiliser ne sont
                                      accordés.
                                  </p>
                                  <p>
                                      <strong>
                                          6. Application de l’entente d’adhésion du membre et des politiques
                                      </strong>
                                  </p>
                                  <p>
                                      WHSCorp a le droit, mais non l’obligation, de suspendre ou d’annuler
                                      votre accès à la plateforme de WHSCorp si elle croit que vous avez
                                      violé la lettre ou l'esprit de la présente entente, agi d’une manière
                                      incompatible avec celle-ci ou violé nos droits ou ceux d’une autre
                                      partie. Sans limiter les autres recours de WHSCorp, nous pouvons
                                      suspendre ou résilier votre compte et refuser de vous redonner accès à
                                      la plateforme de WHSCorp si : i) vous violez toute modalité de la
                                      présente entente ou des autres politiques et procédures écrites
                                      publiées sur le site, ii) nous sommes incapables de vérifier ou
                                      d’authentifier tout renseignement que vous nous fournissez ou iii) nous
                                      croyons que vos actions pourraient engager votre responsabilité ou
                                      celles des autres membres, des distributeurs ou de WHSCorp. Une fois
                                      que votre compte est suspendu ou résilié, vous NE POUVEZ PAS continuer
                                      d’utiliser la plateforme de WHSCorp au moyen d’un compte différent ni
                                      vous réinscrire en créant un nouveau compte. Toute violation de la
                                      présente entente peut donner lieu à des poursuites dans la pleine
                                      mesure permise par la loi et peut entraîner des pénalités et des
                                      sanctions supplémentaires. Lorsque votre compte de membre est annulé,
                                      vous ne pouvez plus accéder à toute partie de la plateforme de WHSCorp,
                                      y compris les données, les fichiers et tout autre matériel que vous
                                      avez stockés sur la plateforme de WHSCorp ou auprès de WHSCorp.
                                  </p>
                                  <p>
                                      <strong>7. Renseignements confidentiels</strong>
                                  </p>
                                  <p>
                                      Si un membre, un distributeur ou WHSCorp fournit des renseignements
                                      confidentiels (définis ci-dessous), le destinataire doit protéger la
                                      confidentialité des renseignements confidentiels avec le même degré de
                                      diligence dont il fait preuve pour protéger ses propres renseignements
                                      confidentiels, qui ne doit en aucun cas être inférieur à la diligence
                                      raisonnable. De plus, le destinataire ne doit pas : i) divulguer les
                                      renseignements confidentiels à quiconque sauf, dans le cas de WHSCorp,
                                      à un membre ou à un distributeur ayant conclu un contrat de services et
                                      ii) utiliser les renseignements confidentiels, sauf dans la mesure
                                      nécessaire pour exécuter les services liés au bon de commande pertinent
                                      (y compris, sans s’y limiter, le stockage ou la transmission de
                                      renseignements confidentiels sur la plateforme de WHSCorp ou au moyen
                                      de celle-ci afin qu’ils soient utilisés par le distributeur).
                                  </p>
                                  <p>
                                      <strong>8. Déni de garantie</strong>
                                  </p>
                                  <p>
                                      NONOBSTANT TOUTE MENTION CONTRAIRE SUR LA PLATEFORME DE WHSCORP (Y
                                      COMPRIS, SANS S’Y LIMITER, SUR LE SITE) OU DE LA PART D’UN REPRÉSENTANT
                                      DE WHSCORP, WHSCORP NE FAIT AUCUNE DÉCLARATION ET N’ACCORDE AUCUNE
                                      GARANTIE RELATIVEMENT À LA FIABILITÉ, À L’ACTUALITÉ, À LA QUALITÉ, À LA
                                      CONVENANCE, À LA DISPONIBILITÉ, À LA SÉCURITÉ, À L'EXACTITUDE OU À
                                      L’EXHAUSTIVITÉ DES SERVICES, À LA PLATEFORME DE WHSCORP, À LA QUALITÉ
                                      OU À LA CAPACITÉ DU MEMBRE OU DU DISTRIBUTEUR, OU À UN PRODUIT, UN
                                      ARTICLE OU UNE ACTIVITÉ SE RAPPORTANT À LA PRÉSENTE ENTENTE
                                      (COLLECTIVEMENT, LES « ARTICLES EXCLUS »). WHSCORP NE FAIT AUCUNE
                                      DÉCLARATION ET N’ACCORDE AUCUNE GARANTIE VOULANT QUE i) L’UTILISATION
                                      DE LA PLATEFORME DE WHSCORP SOIT SÉCURITAIRE, OPPORTUNE, SANS
                                      INTERRUPTION OU EXEMPTE D’ERREURS, OU COMPATIBLE AVEC D’AUTRE MATÉRIEL
                                      OU D’AUTRES APPLICATIONS, SYSTÈMES OU DONNÉES, ii) LES ARTICLES EXCLUS
                                      RÉPONDENT À VOS EXIGENCES OU À VOS ATTENTES, iii) LES DONNÉES STOCKÉES
                                      SOIENT EXACTES OU FIABLES, iv) LA QUALITÉ DES ARTICLES EXCLUS, AINSI
                                      QUE DES PRODUITS, DES SERVICES, DES RENSEIGNEMENTS OU DE TOUT AUTRE
                                      MATÉRIEL ACHETÉS OU OBTENUS AUPRÈS DE VOUS PAR L’INTERMÉDIAIRE DE LA
                                      PLATEFORME DE WHSCORP, RÉPONDENT À VOS EXIGENCES OU À VOS ATTENTES, v)
                                      LES ERREURS OU LES DÉFAUTS DANS LES ARTICLES EXCLUS SOIENT CORRIGÉS OU
                                      vi) LA PLATEFORME DE WHSCORP SOIT EXEMPTE DE VIRUS OU D'AUTRES ÉLÉMENTS
                                      NUISIBLES. LES ARTICLES EXCLUS VOUS SONT STRICTEMENT FOURNIS « TELS
                                      QUELS ». PAR LES PRÉSENTES, WHSCORP DÉCLINE, DANS LA PLEINE MESURE
                                      PERMISE PAR LA LOI, TOUTES LES CONDITIONS, DÉCLARATIONS ET GARANTIES,
                                      QU’ELLES SOIENT EXPLICITES OU IMPLICITES, D’ORIGINE LÉGISLATIVE OU
                                      AUTRE, Y COMPRIS, SANS S’Y LIMITER, TOUTE CONDITION OU GARANTIE DE
                                      QUALITÉ MARCHANDE, D’ADÉQUATION À UN USAGE PARTICULIER OU DE
                                      NON-VIOLATION DES DROITS DES TIERS. WHSCORP NE FAIT AUCUNE DÉCLARATION
                                      ET N’ACCORDE AUCUNE GARANTIE QUANT À LA FIABILITÉ, À LA SÉCURITÉ, À
                                      L’ACTUALITÉ, À LA QUALITÉ, À LA CONVENANCE OU À LA DISPONIBILITÉ DES
                                      ARTICLES EXCLUS ET DES SERVICES, DES PRODUITS OU DES BIENS REÇUS DE LA
                                      PART DE DISTRIBUTEURS OU DE TIERS DANS LE CADRE DE L’UTILISATION DES
                                      ARTICLES EXCLUS. VOUS RECONNAISSEZ ET CONVENEZ QUE LE RISQUE DÉCOULANT
                                      DES ARTICLES EXCLUS VOUS INCOMBE ENTIÈREMENT, DANS LA PLEINE MESURE
                                      PERMISE PAR LA LOI. LA PLATEFORME DE WHSCORP PEUT FAIRE L’OBJET DE
                                      LIMITES, DE RETARDS ET D’AUTRES PROBLÈMES INHÉRENTS À L’UTILISATION
                                      D’INTERNET ET DES COMMUNICATIONS ÉLECTRONIQUES. WHSCORP N'EST PAS
                                      RESPONSABLE DES RETARDS, DES ÉCHECS DE LIVRAISON OU D'AUTRES DOMMAGES
                                      DE QUELQUE NATURE QUE CE SOIT DÉCOULANT DE CES PROBLÈMES.
                                  </p>
                                  <p>
                                      <strong>9. Limitation de responsabilité</strong>
                                  </p>
                                  <p>
                                      LA RESPONSABILITÉ TOTALE DE WHSCORP NE PEUT EN AUCUN CAS DÉPASSER 2 500
                                      $CA. WHSCORP NE PEUT EN AUCUN CAS ÊTRE TENUE RESPONSABLE ENVERS
                                      QUICONQUE DE DOMMAGES INDIRECTS, PUNITIFS, SPÉCIAUX, EXEMPLAIRES,
                                      ACCESSOIRES, CONSÉCUTIFS OU AUTRES DE QUELQUE NATURE QUE CE SOIT (Y
                                      COMPRIS UNE BLESSURE CORPORELLE OU LA PERTE DE DONNÉES, DE REVENUS, DE
                                      PROFITS, DE JOUISSANCE OU D’UN AUTRE AVANTAGE ÉCONOMIQUE). WHSCORP NE
                                      PEUT ÊTRE TENUE RESPONSABLE DES PERTES, DES DOMMAGES OU DES PRÉJUDICES
                                      QUE VOUS POURRIEZ SUBIR, Y COMPRIS, SANS S’Y LIMITER, CEUX QUI
                                      DÉCOULENT DES ARTICLES EXCLUS, NOTAMMENT L’UTILISATION DE LA PLATEFORME
                                      DE WHSCORP OU L’INCAPACITÉ DE L’UTILISER, DE LA QUALITÉ OU LA CAPACITÉ
                                      DU MEMBRE OU DU DISTRIBUTEUR, D’UNE ATTENTE DE VOTRE PART QUANT À
                                      L’EXHAUSTIVITÉ, À L’EXACTITUDE OU À L’EXISTENCE DE TOUTE PUBLICITÉ, OU
                                      ENCORE DE TOUTE RELATION OU TRANSACTION ENTRE VOUS ET UN FOURNISSEUR DE
                                      SERVICES, UN ANNONCEUR OU UN COMMANDITAIRE TIERS DONT LA PUBLICITÉ
                                      FIGURE SUR LA PLATEFORME DE WHSCORP OU QUI EST RECOMMANDÉ PAR WHSCORP
                                      OU SUR LA PLATEFORME DE WHSCORP, MÊME SI WHSCORP A ÉTÉ AVISÉE AU
                                      PRÉALABLE DE LA POSSIBILITÉ DE TELS DOMMAGES. VOUS ÊTES LE SEUL
                                      RESPONSABLE DES DÉCISIONS QUE VOUS PRENEZ RELATIVEMENT AUX PRODUITS OU
                                      AUX ARTICLES OFFERTS AU MOYEN DE LA PLATEFORME DE WHSCORP. NOUS
                                      N’ÉVALUERONS PAS LA CONVENANCE, LA LÉGALITÉ OU LA CAPACITÉ DES MEMBRES,
                                      DES DISTRIBUTEURS OU DES AUTRES TIERS. VOUS RENONCEZ EXPRESSÉMENT À
                                      TOUTE RESPONSABILITÉ, RÉCLAMATION OU CAUSE D'ACTION ET AUX DOMMAGES
                                      DÉCOULANT DE VOTRE UTILISATION DE LA PLATEFORME DE WHSCORP OU SE
                                      RAPPORTANT DE QUELQUE MANIÈRE QUE CE SOIT AU MEMBRE, AU DISTRIBUTEUR OU
                                      AUX TIERS QUI VOUS ONT ÉTÉ PRÉSENTÉS SUR LA PLATEFORME DE WHSCORP, OU
                                      RELATIVEMENT À L’EXÉCUTION DE TOUTE OBLIGATION À L'ÉGARD D’UN MEMBRE OU
                                      D’UN DISTRIBUTEUR, AINSI QU’À TOUTES LES PERTES AFFÉRENTES.
                                  </p>
                                  <p>
                                      <strong>10. Indemnisation</strong>
                                  </p>
                                  <p>
                                      <strong>10.1 Droits de propriété</strong>
                                  </p>
                                  <p>
                                      Chaque membre doit indemniser WHSCorp et ses filiales et sociétés
                                      affiliées, ainsi que chacun de leurs actionnaires, administrateurs,
                                      dirigeants, mandataires, employés et représentants (individuellement,
                                      une « partie indemnisée », et collectivement, les « parties indemnisées
                                      ») et les dégager de toute responsabilité à l'égard des réclamations,
                                      des dommages, des obligations, des coûts et des frais (y compris, sans
                                      s’y limiter, les honoraires d'avocat raisonnables et tous les coûts et
                                      les frais connexes) découlant d’une réclamation, d’un jugement ou d’une
                                      décision voulant qu’un bon de commande ou une action ou une omission de
                                      ce membre ou du distributeur viole les droits de propriété ou d’autres
                                      droits d’un tiers.
                                  </p>
                                  <p>
                                      <strong>10.2 Indemnisation par le membre</strong>
                                  </p>
                                  <p>
                                      Chaque membre doit indemniser les parties indemnisées et les dégager de
                                      toute responsabilité à l'égard des réclamations, des dommages, des
                                      obligations, des coûts et des frais (y compris, sans s’y limiter, les
                                      honoraires d'avocat raisonnables et tous les coûts et les frais
                                      connexes) découlant : i) de l’utilisation des services par ce membre, y
                                      compris, sans s’y limiter, les réclamations effectuées par ou au nom de
                                      tout distributeur, ii) d’un bon de commande établi entre ce membre et
                                      un distributeur ou iii) de toute violation de leurs obligations prévues
                                      aux présentes.
                                  </p>
                                  <p>
                                      <strong>10.3 Sens élargi</strong>
                                  </p>
                                  <p>
                                      Toute indemnité et toute décharge de responsabilité accordées à WHSCorp
                                      doivent aussi être interprétées comme une indemnité ou une décharge de
                                      responsabilité, selon le cas, accordée aux parties indemnisées.
                                  </p>
                                  <p>
                                      <strong>10.4 Règlement des différends et lois applicables</strong>
                                  </p>
                                  <p>
                                      La présente entente et toute action, controverse ou réclamation ou tout
                                      différend s’y rapportant sont régis par les lois de la province de
                                      Québec, sans égard aux dispositions sur les conflits de lois. Le lieu
                                      du procès pour toute action se rapportant à la présente entente est le
                                      district de Montréal, et chacune des parties renonce par les présentes
                                      à toute objection à la compétence exclusive de ces tribunaux.
                                      Cependant, en cas de violation ou de détournement réel ou imminent des
                                      droits de propriété de WHSCorp, WHSCorp peut, à sa discrétion, entamer
                                      des poursuites judiciaires dans tout territoire jugé nécessaire ou
                                      souhaitable.
                                  </p>
                                  <p>
                                      <strong>10.5 Conseils juridiques indépendants</strong>
                                  </p>
                                  <p>
                                      Vous reconnaissez que WHSCorp ne fournit aucun conseil juridique, que
                                      vous avez eu l’occasion de recevoir des conseils juridiques
                                      indépendants relativement à la présente entente et que vous comprenez
                                      sa nature et ses conséquences.
                                  </p>
                                  <p>
                                      <strong>11. Durée et résiliation</strong>
                                  </p>
                                  <p>
                                      <strong>11.1 Durée</strong>
                                  </p>
                                  <p>
                                      La présente entente commence à la date d’entrée en vigueur et se
                                      poursuit jusqu’à sa résiliation conformément à l’article 11.2
                                      ci-dessous.
                                  </p>
                                  <p>
                                      <strong>11.2 Résiliation</strong>
                                  </p>
                                  <p>
                                      WHSCorp ou le membre peut résilier la présente entente en tout temps,
                                      avec ou sans motif, immédiatement si a) le membre ferme son compte en
                                      cliquant sur « Preferences », puis sur « My Account » sur la plateforme
                                      de WHSCorp et en appuyant sur le bouton « Close Account » ou b) WHSCorp
                                      vous envoie une confirmation par courriel, conformément à l’article
                                      12.3 ci-dessous, indiquant qu’elle a fermé votre compte de membre.
                                      Cependant, une telle résiliation pour des raisons de commodité ne nuit
                                      pas à la validité des bons de commande qui ont été signés avant la
                                      résiliation, et la présente entente continue de s’appliquer à l’égard
                                      de ces bons de commande.
                                  </p>
                                  <p>
                                      <strong>11.3 Conséquences de la résiliation</strong>
                                  </p>
                                  <p>
                                      Toutes les modalités énoncées dans les présentes qui, par leur nature,
                                      continuent de s’appliquer après la résiliation de la présente entente,
                                      y compris, sans s’y limiter, les dispositions des articles 7, 8, 9 et
                                      10 (et toute indemnité ou décharge de responsabilité prévue ailleurs
                                      dans la présente entente).
                                  </p>
                                  <p>
                                      <strong>12. Tout le reste</strong>
                                  </p>
                                  <p>
                                      <strong>12.1 Intégralité de l’entente</strong>
                                  </p>
                                  <p>
                                      La présente entente constitue l’intégralité de l'entente entre les
                                      parties relativement à son objet. Elle annule et remplace toutes les
                                      discussions, ententes, déclarations, garanties et autres communications
                                      antérieures ou concomitantes entre elles.
                                  </p>
                                  <p>
                                      <strong>12.2 Conformité</strong>
                                  </p>
                                  <p>
                                      Les membres ne doivent pas violer les lois ou les droits de tiers sur
                                      la plateforme de WHSCorp ou relativement à celle-ci. Sans limiter la
                                      portée générale de ce qui précède, les membres acceptent de se
                                      conformer à toutes les lois de contrôle des importations et des
                                      exportations applicables et à tous les droits de propriété de tiers.
                                  </p>
                                  <p>
                                      <strong>12.3 Avis : consentement aux avis électroniques</strong>
                                  </p>
                                  <p>
                                      Vous consentez à l’utilisation a) d’un moyen électronique pour remplir
                                      la présente entente et transmettre des avis conformément à celle-ci et
                                      b) d’un document électronique pour stocker les renseignements se
                                      rapportant à la présente entente ou à votre utilisation de la
                                      plateforme de WHSCorp. Les avis en vertu des présentes sont valides
                                      uniquement s’ils sont faits par écrit et remis a) par WHSCorp par
                                      courriel (dans tous les cas, à l'adresse que vous fournissez), b) sous
                                      la forme d’une publication sur le site de WHSCorp Site ou c) par vous
                                      par courriel à
                                      <a
                                          href="https://whscorp.com/NRPortbl/SSDocs/RGREENBERG/support@whscorp.com"
                                      >
                                          support@whscorp.com
                                      </a>
                                      ) ou à toute autre adresse désignée par écrit par WHSCorp. La date de
                                      réception est réputée être la date à laquelle l'avis est transmis.
                                  </p>
                                  <p>
                                      <strong>12.4 Absence de renonciation</strong>
                                  </p>
                                  <p>
                                      Un défaut ou un retard par une partie dans l'exercice d’un droit ou
                                      l’exécution d’une réclamation ne constitue pas une renonciation à ce
                                      droit ou à cette réclamation et ne porte aucunement atteinte au droit
                                      d'exécution ou d’exercice ultérieur de cette partie, à moins que la
                                      partie accorde une renonciation écrite, signée par un représentant
                                      dûment autorisé de chaque partie.
                                  </p>
                                  <p>
                                      <strong>12.5 Cessibilité</strong>
                                  </p>
                                  <p>
                                      Les membres ne peuvent pas céder la présente entente, ni les droits ou
                                      obligations qu’elle prévoit, sans le consentement écrit préalable de
                                      WHSCorp sous la forme d’un document écrit signé par un représentant
                                      dûment autorisé de WHSCorp (et, aux fins du présent article 12.5, un
                                      document écrit exclut expressément les communications électroniques
                                      comme les courriels et les avis électroniques, mais comprend les
                                      télécopies). WHSCorp peut céder librement la présente entente sans le
                                      consentement des membres. Toute tentative de cession ou de transfert
                                      qui viole le présent article est nulle et sans effet. Sous réserve des
                                      restrictions qui précèdent, la présente entente s’applique au profit
                                      des successeurs et des ayants droit autorisés des parties.
                                  </p>
                                  <p>
                                      <strong>12.6 Dissociabilité</strong>
                                  </p>
                                  <p>
                                      Si toute disposition de la présente entente est jugée illégale,
                                      invalide ou inexécutoire, en tout ou en partie, en vertu des lois
                                      applicables, cette disposition totale ou partielle est sans effet dans
                                      le territoire de compétence ou elle a été jugée ainsi dans la mesure de
                                      cette illégalité, de cette invalidité ou de cette inexécutabilité, et
                                      doit être réputée modifiée dans la mesure nécessaire pour respecter les
                                      lois applicables de manière à donner un effet maximal à l’intention des
                                      parties. L’illégalité, l’invalidité ou l’inexécutabilité de cette
                                      disposition dans ce territoire de compétence ne nuit aucunement à la
                                      légalité, à la validité ou à l’exécutabilité de cette disposition dans
                                      tout autre territoire de compétence ni de toute autre disposition dans
                                      tout territoire de compétence.
                                  </p>
                                  <p>
                                      <strong>12.7 Language</strong>
                                      <strong></strong>
                                  </p>
                                  <p>
                                      You have requested and agreed that this Agreement be drafted in
                                      English.
                                      <em>
                                          Vous avez demandé et accepté que cette convention soit rédigée en
                                          anglais
                                      </em>
                                      .
                                  </p>
                                  <p>
                                      <strong>13. Définitions</strong>
                                  </p>
                                  <p>
                                      « renseignements confidentiels »“désigne les renseignements fournis par
                                      nous, par un membre ou par un distributeur relativement à l’utilisation
                                      de la plateforme de WHSCorp, qu’ils soient sous forme concrète,
                                      électronique, verbale, graphique, visuelle ou autre. Les renseignements
                                      confidentiels ne comprennent pas le matériel ou les renseignements qui
                                      :
                                  </p>
                                  <p>
                                      a) sont généralement connus par les parties sans que cette situation
                                      découle d’une action ou d’une omission d’une partie;
                                  </p>
                                  <p>
                                      b) ont été reçus de façon légitime sans restriction en matière de
                                      divulgation de la part d’un tiers ayant le droit de les diffuser;
                                  </p>
                                  <p>
                                      c) étaient déjà connus par une partie avant de les recevoir de l’autre
                                      partie et qui n’ont pas été reçus de la part d’un tiers qui viole ses
                                      obligations de confidentialité; ou
                                  </p>
                                  <p>
                                      d) ont été élaborés de façon indépendante par une partie sans utiliser
                                      les renseignements confidentiels.
                                  </p>
                                  <p>
                                      « date d’entrée en vigueur » désigne la date d’acceptation de la
                                      présente entente.
                                  </p>
                                  <p>
                                      « distributeur » désigne le partenaire commercial, à savoir un
                                      distributeur ou un fabricant de matériel de technologie de
                                      l’information, avec lequel vous avez déjà conclu une entente distincte
                                      qui vous donne le droit de mener des affaires avec lui et à l’égard de
                                      laquelle WHSCorp fournit les services.
                                  </p>
                                  <p>
                                      « membre Elite » désigne un membre qui choisit d’adhérer à titre de
                                      membre Elite dans son profil d’inscription et qui a payé les droits
                                      d’adhésion mensuels correspondants.
                                  </p>
                                  <p>
                                      « membre » désigne la personne qui détient un compte sur la plateforme
                                      de WHSCorp.
                                  </p>
                                  <p>
                                      « membre Pro » désigne un membre qui choisit d’adhérer à titre de
                                      membre Pro dans son profil d’inscription et qui a payé les droits
                                      d’adhésion mensuels correspondants.
                                  </p>
                                  <p>
                                      « droits de propriété » désigne tous les droits, titres et intérêts
                                      relatifs aux droits d’auteur, aux topographies de circuit intégré, aux
                                      dessins industriels, aux marques de commerce, aux marques de service,
                                      aux noms commerciaux, aux secrets commerciaux, aux brevets et aux
                                      autres droits de propriété intellectuelle reconnus dans tout territoire
                                      de compétence, qu’ils soient opposables ou non.
                                  </p>
                                  <p>
                                      « bon de commande » désigne un bon de commande envoyé par un membre à
                                      l’un de ses distributeurs au moyen de la plateforme de WHSCorp.
                                  </p>
                                  <p>
                                      « contrat de services » désigne, après la prestation des services, un
                                      contrat entre un membre et un distributeur qui énonce les modalités de
                                      leur entente relative à l’achat et à la vente de matériel de
                                      technologie de l’information.
                                  </p>
                                  <p>
                                      « services » désigne les services en ligne offerts par WHSCorp par
                                      l’intermédiaire de la plateforme de WHSCorp dans le cadre des divers
                                      programmes décrits à
                                      https://www.whscorp.com/registration_plans_01.aspx.
                                  </p>
                                  <p>
                                      Si vous avez des questions ou des commentaires sur les présentes
                                      modalités, vous pouvez toujours communiquer avec nous à
                                      <a
                                          href="https://whscorp.com/NRPortbl/SSDocs/RGREENBERG/support@whscorp.com"
                                      >
                                          support@whscorp.com
                                      </a>
                                      .
                                  </p>
                              </div>
                              <br clear="all"/>
                              <div>
                                  <p>
                                      <strong><u>SECTION 2 :</u></strong>
                                  </p>
                                  <p>
                                      <strong>
                                          MODALITÉS DU PROGRAMME ELITE 300 MASTERMIND DANS LE CADRE DE LA
                                          CHANNEL PARTNER ALLIANCE – NOVEMBRE 2018
                                      </strong>
                                  </p>
                                  <p>
                                      Voici les modalités du programme Elite 300 Mastermind dans le cadre des
                                      avantages offerts aux membres de la Channel Partner Alliance en
                                      novembre 2018. En devenant membre, vous acceptez les présentes
                                      modalités.
                                  </p>
                                  <p>
                                      <strong>
                                          L’option Standard du programme Elite 300 Mastermind comprend :
                                      </strong>
                                  </p>
                                  <p>
                                      1 événement en personne (de deux jours) par période de 12 mois
                                      (participation à l’un des trois événements régionaux)
                                  </p>
                                  <p>
                                      2 séances Mastermind pendant l’événement en direct
                                  </p>
                                  <p>
                                      1 nuit d’hébergement à l’hôtel pendant l’événement, ainsi que les repas
                                      et boissons prévus pendant les activités officielles
                                  </p>
                                  <p>
                                      12 classes de maître virtuelles par période de 12 mois, ainsi qu’un
                                      accès à nos ressources permettant de trouver des outils pour exploiter
                                      votre entreprise avec efficacité
                                  </p>
                                  <p>
                                      Rabais spéciaux sur les outils et les services en vedette
                                  </p>
                                  <p>
                                      Pour consulter une liste complète des services offerts aux membres,
                                      visitez le
                                      <a href="http://www.elite300mastermind.com/">
                                          www.elite300mastermind.com
                                      </a>
                                      et rendez-vous sous l’onglet « Memberships ». Seule l’option Standard
                                      est offerte durant la présente phase initiale.
                                  </p>
                                  <p>
                                      Les membres peuvent passer automatiquement à un niveau supérieur en
                                      fonction du montant des fonds de développement marketing perçus en leur
                                      nom au cours de chaque période d’un an. L’adhésion peut être résiliée
                                      sans préavis si les fonds de développement marketing perçus ne
                                      suffisent pas pour payer les frais d’adhésion indiqués.
                                  </p>
                                  <p>
                                      <strong> </strong>
                                  </p>
                                  <p>
                                      <strong>
                                          Autorisation de demander, de percevoir et d’utiliser des fonds de
                                          développement marketing
                                      </strong>
                                  </p>
                                  <p>
                                      Le programme Channel Partner Alliance consiste à négocier des fonds de
                                      développement marketing auprès de divers fournisseurs pour aider ses
                                      membres à payer leurs frais et des services connexes. Lorsque vous vous
                                      inscrivez à ce programme, vous acceptez de permettre à WHS et à
                                      TechnoPlanet, aux termes du programme Channel Partner Alliance
                                      (collectivement, la « Société »), de demander des fonds de
                                      développement marketing à tous les distributeurs et les fournisseurs
                                      qui participent au programme et qui utilisent lesdits fonds pour
                                      financer tous les coûts associés aux services que nous vous offrons.
                                      Vous convenez aussi d’informer les fournisseurs, s’ils communiquent
                                      avec vous, que vous avez autorisé la Channel Partner Alliance à
                                      demander des fonds de développement marketing pour financer vos frais
                                      d’adhésion. Nous pouvons aussi fournir une lettre d’autorisation que
                                      vous pouvez signer et que nous pouvons montrer aux fournisseurs, sur
                                      demande.
                                  </p>
                                  <p>
                                      <strong> </strong>
                                  </p>
                                  <p>
                                      <strong>Durée</strong>
                                  </p>
                                  <p>
                                      Le programme a une durée de douze (12) mois (ci-après désignée la «
                                      période d’adhésion »). Le membre comprend que tous les avantages se
                                      renouvellent à la fin de la période d’adhésion, mais que les services
                                      ou les fonds de développement marketing inutilisés, s’il y a lieu, ne
                                      se reportent pas aux périodes d’adhésion subséquentes. Tous les
                                      avantages du membre doivent être utilisés pendant la période
                                      d’engagement.
                                  </p>
                                  <p>
                                      <strong>Mode de paiement, s’il y a lieu</strong>
                                  </p>
                                  <p>
                                      Si le membre s’inscrit à un niveau supérieur ou à des services
                                      supplémentaires sans fonds de développement marketing, il doit payer
                                      les droits d’adhésion et les services au moyen d’une carte MasterCard,
                                      Visa ou American Express (le paiement est traité par PayPal). Les
                                      chèques postdatés sont aussi acceptés. Un rabais de 5 % est offert
                                      lorsque vous payez en entier les droits d’adhésion annuels de façon
                                      anticipée, s’il y a lieu.
                                  </p>
                                  <p>
                                      <strong> </strong>
                                  </p>
                                  <p>
                                      <strong>Politique de remboursement des fonds perçus</strong>
                                  </p>
                                  <p>
                                      Aucun remboursement n’est émis et aucun transfert n’est effectué.
                                  </p>
                                  <p>
                                      <strong>Confidentialité</strong>
                                  </p>
                                  <p>
                                      La Société respecte la vie privée du membre et exige que le membre
                                      respecte la vie privée de la Société, des autres membres et de tous les
                                      participants aux événements (ci-après désignés les « participants »).
                                      Par conséquent, considérez le présent paragraphe comme une entente
                                      réciproque de non-divulgation. Les renseignements confidentiels
                                      communiqués par la Société, tout représentant de la Société ou les
                                      participants sont confidentiels et exclusifs, et appartiennent
                                      uniquement à la partie qui les divulgue. Toutes les parties conviennent
                                      de ne pas divulguer, révéler ou utiliser des renseignements
                                      confidentiels ou des transactions pendant des discussions ou autrement.
                                  </p>
                                  <p>
                                      <strong>Billets d’avion et préparatifs de voyage</strong>
                                  </p>
                                  <p>
                                      Le membre est uniquement responsable : 1) de réserver des billets
                                      d’avion et de faire des préparatifs de voyage pour les dates des
                                      événements; 2) d’obtenir tous les documents de voyage et les visas
                                      nécessaires; 3) de respecter l’ensemble des lois, des règlements, des
                                      ordonnances, des demandes et des exigences de chaque pays visité par le
                                      membre; et 4) de payer les frais ou les coûts associés aux retards, aux
                                      annulations ou aux changements touchant les heures d’arrivée ou de
                                      départ des vols du membre.
                                  </p>
                                  <p>
                                      <strong>Aucun transfert de propriété intellectuelle</strong>
                                  </p>
                                  <p>
                                      Toute la propriété intellectuelle, y compris les événements ou les
                                      documents relatifs au programme de la Société qui sont protégés par le
                                      droit d’auteur, demeure la propriété exclusive de la Société. Aucune
                                      licence permettant la vente, la reproduction ou la distribution des
                                      documents de la Société n’est accordée de manière explicite ou
                                      implicite. Le membre convient de ne pas violer les droits d’auteur, les
                                      brevets, les marques de commerce, les secrets commerciaux ou les autres
                                      droits de propriété intellectuelle de la Société, des membres ou des
                                      participants.
                                  </p>
                                  <p>
                                      <strong> </strong>
                                  </p>
                                  <p>
                                      <strong>Responsabilité et résultats du membre</strong>
                                  </p>
                                  <p>
                                      Les événements et les services sont conçus strictement à des fins de
                                      formation commerciale. Le membre accepte et convient qu’il est
                                      entièrement responsable des progrès qu’il réalise et des résultats
                                      qu’il tire des événements, des outils et de tous les services offerts.
                                      La Société ne fait aucune déclaration et n’accorde aucune garantie
                                      orale ou écrite. Le membre comprend que les résultats de chaque membre
                                      peuvent varier. Le membre reconnaît qu’il existe, comme pour toute
                                      entreprise commerciale, un risque inhérent de perte de capital et qu’il
                                      n’est pas garanti qu’il atteigne ses objectifs en participant à toute
                                      activité du programme.
                                  </p>
                                  <p>
                                      <strong>Avertissement</strong>
                                  </p>
                                  <p>
                                      Le membre reconnaît que ni la Société, ni ses sociétés affiliées, ni
                                      aucun de leurs employés, mandataires, tiers ou concédants de licence
                                      respectifs ne garantissent que les services seront ininterrompus ou
                                      exempts d’erreurs et n’accordent de garantie relativement aux résultats
                                      pouvant être tirés des événements et des services et relativement à
                                      l’actualité, à l’ordre, à l’exactitude, à la fiabilité, à
                                      l’exhaustivité ou au contenu de tout renseignement ou service fourni
                                      dans le cadre des événements et des services.
                                  </p>
                                  <p>
                                      <strong>Modification des modalités</strong>
                                  </p>
                                  <p>
                                      Les présentes modalités peuvent être modifiées au moyen d’un préavis de
                                      30 jours. Veuillez suivre le même lien vers cette page pour consulter
                                      les modalités mises à jour. Communiquez avec la Société pour en savoir
                                      plus.
                                  </p>
                                  <p>
                                      © TechnoPlanet Productions Inc. Tous droits réservés.
                                  </p>
                                  <p>
                                      <strong><u>SECTION 3 :</u></strong>
                                  </p>
                                  <p>
                                      <strong>CONDITIONS D’UTILISATION CONJOINTES</strong>
                                      <strong></strong>
                                  </p>
                                  <p>
                                      <strong>1. </strong>
                                      <strong><u>Acceptation des conditions du programme</u></strong>
                                      <u></u>
                                  </p>
                                  <p>
                                      Les présentes conditions d'utilisation (l’« <strong>entente</strong> »)
                                      est un contrat entre vous (le « <strong>membre</strong> »), 8174563
                                      Canada Inc, une entité constituée au Canada (« <strong>WHS</strong> »),
                              et TechnoPlanet Productions, Inc., une société constituée en Ontario («<strong>TechnoPlanet</strong> » et, avec WHS, les «        <strong>fournisseurs de services</strong> »).
                                  </p>
                                  <p>
                                      WHS exploite un agrégateur en ligne, qui permet à ses membres, à savoir
                                      des revendeurs de matériel de technologie de l’information, de
                                      rechercher des renseignements sur le prix et la disponibilité de
                                      produits de technologie de l’information sur les sites Web de plusieurs
                              distributeurs de matériel de technologie de l’information (la «        <strong>plateforme de WHS</strong> »). TechnoPlanet exploite une
                                      plateforme éducative qui offre des cours, des événements et des
                                      webinaires en ligne visant à améliorer la rentabilité des revendeurs de
                              matériel de technologie de l’information (la «        <strong>plateforme de TechnoPlanet</strong> »).
                                  </p>
                                  <p>
                                      Les fournisseurs de services souhaitent offrir au membre un programme
                                      de fidélisation conçu pour les revendeurs de matériel de technologie de
                                      l’information qui donne accès à la fois à la plateforme de WHS
                                      (programme Elite) et à la plateforme de TechnoPlanet (programme
                                      Standard) (le « <strong>programme</strong> »).
                                  </p>
                                  <p>
                                      Le membre doit lire et accepter toutes les conditions figurant dans la
                                      présente entente, ainsi que les conditions relatives à la plateforme de
                                      WHS
                                      <a href="https://www.whscorp.com/readterms.aspx?param=2">
                                          https://www.whscorp.com/readterms.aspx?param=2
                                      </a>
                                      (les « <strong>conditions d’utilisation de WHSCorp </strong>») et à la
                                      plateforme de TechnoPlanet
                                      <a href="http://technoplanet.com/300Elite/Terms.pdf">
                                          http://technoplanet.com/300Elite/Terms.pdf
                                      </a>
                              et figurant ci-dessous (les «        <strong>conditions d’utilisation de Channel Partners Alliance </strong>
                              » et, avec les conditions d'utilisation de WHSCorp, les «        <strong>conditions d’utilisation des fournisseurs de services</strong>
                                      ») afin de s’inscrire au programme et de profiter du logiciel et des
                                      services connexes.
                                  </p>
                                  <p>
                                      Il demeure entendu que tous les membres qui se sont inscrits au
                                      programme en cliquant sur « Join Now » à la page Web intitulée «
                                      Registration » sur la plateforme de WHS (
                                      <a href="https://www.whscorp.com/registration_plans_01.aspx">
                                          https://www.whscorp.com/registration_plans_01.aspx
                                      </a>
                                      ) conviennent que leur inscription au programme est régie par les
                                      conditions de la présente entente, les conditions d’utilisation de
                                      WHSCorp et les conditions d’utilisation de Channel Partners Alliance.
                                  </p>
                                  <p>
                                      <strong>2. </strong>
                                      <strong><u>Résiliation</u></strong>
                                  </p>
                                  <p>
                                      Un membre, WHS ou TechnoPlanet peut résilier la présente entente en
                                      tout temps, avec ou sans motif, immédiatement si a) le membre ferme son
                                      compte sur la plateforme de WHS conformément à l’article 11.2 des
                                      conditions d’utilisation de WHSCorp ou ferme son compte sur la
                                      plateforme de TechnoPlanet en cliquant sur « Preferences », puis sur «
                                      My Account » sur la plateforme de WHS, puis en refusant le droit
                                      d’accès à la plateforme de TechnoPlanet en cliquant enfin sur « WHS
                                      without Education », b) WHS résilie le compte du membre sur la
                                      plateforme de WHS conformément à l’article 11.2 des conditions
                                      d’utilisation de WHSCorp ou c) TechnoPlanet résilie le compte du membre
                                      sur la plateforme de TechnoPlanet en lui envoyant un courriel pour l’en
                                      informer.
                                  </p>
                                  <p>
                                      Toute résiliation en vertu des dispositions a), b) ou c) a pour effet
                                      de résilier l’inscription du membre au programme. WHS et TechnoPlanet
                                      ont chacune le droit, à leur entière discrétion respective, de résilier
                                      la présente entente, ainsi que les conditions d’utilisation de WHSCorp
                                      ou les conditions d’utilisation de Channel Partners Alliance,
                                      respectivement, auprès de tout membre et de résilier l’inscription de
                                      ce membre au programme (le fournisseur de service qui résilie
                              l’inscription du membre au programme est ci-après désigné le «        <strong>fournisseur de services à l’origine de la résiliation</strong>
                                      »). Cependant, la résiliation de la présente entente et des conditions
                                      d’utilisation de WHSCorp ou des conditions d’utilisation de Channel
                                      Partners Alliance, selon le cas, par le fournisseur de services à
                                      l’origine de la résiliation et la résiliation subséquente de
                                      l’inscription du membre au programme empêchent uniquement ce membre de
                                      continuer d’accéder à la plateforme du fournisseur de services à
                                      l’origine de la résiliation et de recevoir les services du fournisseur
                                      de services à l’origine de la résiliation. Il demeure entendu, par
                                      exemple, que la résiliation de la présente entente et des conditions
                                      d’utilisation de Channel Partners Alliance par TechnoPlanet auprès d’un
                                      certain membre n’a pas pour effet de résilier les conditions
                                      d’utilisation de WHSCorp pour ce membre.
                                  </p>
                                  <p>
                                      <strong>3. </strong>
                                      <strong>
                                          <u>
                                              Relation entre le membre, WHS et TechnoPlanet, et
                                              responsabilité
                                          </u>
                                      </strong>
                                  </p>
                                  <p>
                                      Il n’existe aucune coentreprise, association ou relation d’emploi, de
                                      solidarité ou de mandataire entre le membre, TechnoPlanet, WHS ou un
                                      tiers en raison de la présente entente ou de l’inscription au
                                      programme. Le membre reconnaît qu’il a accepté les conditions
                                      d’utilisation des fournisseurs de services distinctes de chacun des
                                      fournisseurs de services respectifs, à savoir les conditions
                                      d’utilisation de WHSCorp et les conditions d’utilisation de Channel
                                      Partners Alliance. Les droits, les intérêts et les obligations figurant
                                      dans les conditions d’utilisation des fournisseurs de services
                                      distinctes de chaque fournisseur de services doivent être interprétés
                                      comme des droits, des intérêts et des obligations contraignants
                                      exclusivement entre le membre et le fournisseur de services qui est
                                      partie à l'entente en question, à moins d’indication expresse contraire
                                      dans les conditions d’utilisation des fournisseurs de services. Par
                                      conséquent, toute responsabilité encourue par un fournisseur de
                                      services qui peut découler des conditions d’utilisation des
                                      fournisseurs de services se rapporte uniquement au fournisseur de
                                      services en question, et ne doit en aucun cas être attribuée à l’autre
                                      fournisseur de services. Il demeure entendu que a) WHS ne peut assumer
                                      toute responsabilité découlant d’un manquement aux obligations de
                                      TechnoPlanet en vertu des conditions d’utilisation de Channel Partners
                                      Alliance et b) TechnoPlanet ne peut assumer toute responsabilité
                                      découlant d’un manquement aux obligations de WHS en vertu des
                                      conditions d’utilisation de WHSCorp.
                                  </p>
                                  <p>
                                      <strong>4. </strong>
                                      <strong><u>Généralités</u></strong>
                                  </p>
                                  <p>
                                      Si toute disposition de la présente entente est jugée invalide ou
                                      inexécutoire, cette disposition est annulée, et les dispositions
                                      restantes continuent de s’appliquer dans la pleine mesure permise par
                                      la loi. Le défaut d’un fournisseur de services d’exercer un droit ou
                                      d’appliquer une disposition de la présente entente ne constitue pas une
                                      renonciation à ce droit ou à cette disposition, à moins que les
                                      fournisseurs de services en conviennent autrement par écrit. La
                                      présente entente, les conditions d’utilisation de WHSCorp et les
                                      conditions d’utilisation de Channel Partners Alliance constituent
                                      l’intégralité de l’entente entre le membre, WHS et TechnoPlanet, et
                                      remplacent toutes les négociations, les discussions ou les ententes
                                      antérieures ou concomitantes, écrites ou orales, entre les parties
                                      relativement à l’objet des présentes.
                                  </p>
                                  <p>
                                      You have requested and agreed that this Agreement be drafted in
                                      English.
                                      <em>
                                          Vous avez demandé et accepté que cette convention soit rédigée en
                                          anglais
                                      </em>
                                      .
                                  </p>
                                  <p>
                                      Si vous avez des questions ou des commentaires concernant la présente
                                      entente, n’hésitez pas à communiquer avec nous à tony@whscorp.com.
                                  </p>
                              </div>
                              </div>
                        </div>
                              <span *ngIf="stepResellerResgister===true"><br>
   By registering, <br>
                              <mat-checkbox  [formControl]="iAgreeFormControl">I agree to <a href="#">WHS Terms of Service</a> and <a href="#">Privacy Policy</a>.</mat-checkbox>
                              <mat-error *ngIf="iAgreeFormControl.hasError('required')">
                                  <strong>*</strong>
                              </mat-error>
                              </span>
                              </li>
                          </ul>
                        </div>
                        <input type="button" name="next" class="next_btn" *ngIf="accountDoesntExist===false" [disabled]="firstNameFormControl.errors || lastNameFormControl.errors  || jobTitleFormControl.errors  || userNameFormControl.errors " (click)="step3Next()" value="Register with WHS" />
                        <input type="button" name="next" class="next_btn" *ngIf="accountDoesntExist===true && stepResellerResgister===false" [disabled]="firstNameFormControl.errors || lastNameFormControl.errors  || jobTitleFormControl.errors  || phoneNumberFormControl.errors || accountTypeFormControl.errors " (click)="step3Next()" value="Register with WHS" />
                        <input type="button" name="next" class="next_btn" *ngIf="stepResellerResgister===true" [disabled]="firstNameFormControl.errors || lastNameFormControl.errors  || jobTitleFormControl.errors  || phoneNumberFormControl.errors || userNameFormControl.errors  || companyNameFormControl.errors  || address1FormControl.errors  || cityFormControl.errors  || postalCodeFormControl.errors || iAgreeFormControl.errors" (click)="stepRegisterResellerToDB()" value="Register with WHS" />
                      </div>

                      <br><br>
                      <div  class="rgstrTxt" *ngIf="step2===true">
                            <div class="columns">
                            <ul class="price">
                              <li class="header">Reseller</li>
                              <li class="grey">Reseller includes VARs, 
                                MSPs, ITSPs 
                                </li>
                              <li>√ Channel community membership</li>
                              <li>√ Realtime Price and Availability</li>
                              <li>√ Order processing</li>
                              <li>√ Yearly events</li>
                              <li>√ Live Mastermind conferences</li>
                              <li>√ Elite 300 Business tools</li>
                              <li>And much more</li>

                             
                              <li class="grey" style="text-align: center;"><a href="#" class="button" (click)="stepRegisterReseller()">Register</a></li>
                            </ul>
                          </div>
                          
                          <div class="columns">
                            <ul class="price">
                              <li class="header">Distributor & Vendor</li>
                              <li class="grey">Distributors, manufacturers 
                                For Hardware, software or Cloud<br>
                                </li>

                                <li>√ Channel community membership</li>
                                <li>√ Realtime Price and Availability</li>
                                <li>√ Yearly vendor events</li>
                                <li>√ Channel manager summit</li>
                                <li>√ Yearly Choice Awards ceremony</li>
                                <li>And much more<br></li>
                                <li>&nbsp;</li>
                                
                              <li class="grey" style="text-align: center;"><a href="#" class="button" (click)="step2Next()">Register</a></li>
                            </ul>
                          </div>      
                          
                          <div class="columns">
                            <ul class="price">
                              <li class="header">Consumer End User</li>
                              <li class="grey">Home users, corporate users,
                                Buyers 
                                </li>
                                <li>√ Realtime Price and Availability</li>
                                <li>√ Local member partners</li>
                                <li>√ Member special discounts</li>
                                <li>And much more</li>
                                <li>&nbsp;</li>
                                <li>&nbsp;</li>
                                <li>&nbsp;</li>
                              <li class="grey" style="text-align: center;"><a href="#" class="button" (click)="stepRegisterEndUser()" >Register</a></li>
                            </ul>
                          </div>
                      </div>
                     
                </fieldset>
               
             </form>
           </div>
          </div>
          
        </div>
       </div>
          
    </div>
    <div class="col-sm" style="background-color:#f3f9fa;"></div><!--yellow-->
  </div>
  
  <div class="row">
    <div class="col" style="background-color:orange;">
        
        <div class="row" style="background-color:#2B2B2B; color:white; ">
             <div class="col-sm" style="padding-top:2%; padding-bottom:2%;"></div>
          <div class="col-sm" style="padding-top:1%; padding-bottom:1%; border-right:1px solid #414141;">
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/new/channelNext.aspx" style=" color:white;">Events</a></p>
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/new/why-choose-us.aspx" style=" color:white;">Why choose WHS</a></p>
          </div>
          <div class="col-sm" style="padding-top:1%; padding-bottom:1%; border-right:1px solid #414141;">
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/new/join-the-channel.aspx" style=" color:white;">Join the channel</a></p>
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/new/contact-us.aspx" style=" color:white;">Contact us </a></p>
          </div>
          <div class="col-sm" style="padding-top:1%; padding-bottom:1%; border-right:1px solid #414141;">
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/login.aspx" style=" color:white;">Sign In</a></p>
              <p style="color:#FFF; line-height:24px;  font-size:13px;"><a href="https://whscorp.com/join_channel.aspx" style=" color:white;">Register</a></p>
          </div>
          <div class="col-sm" style="padding-top:1%; padding-bottom:1%; border-right:1px solid #414141;">
              <p class="text-center">
      <img alt="" src="../assets/FLimages/footer-logo.png"><br />
              <p style="color:#FFF; line-height:24px;  font-size:12px;">WhsCorp.com Community Portal.
      Copyright 2004 - 2020 all rights reserved
              </p>
      
          </div>
          <div class="col-sm" style="padding-top:2%; padding-bottom:2%;"></div>

        </div>
      

    </div>  
      
  
  </div>
<div class="row" style="background-color:#2B2B2B; color:white">

          <div class="col" style="padding-top:0%; padding-bottom:0%;">
                  <div class="footerInfo">


              
                  
                      <div class="row" >
                          <div class="col-sm"></div>
                          <div class="col-sm-7">
                          <p class="text-center">    WHSCorp.com, WHS, WhoHasStock and WhoHasStock.com are trademarks or registered trademarks of 8174563 Canada Inc. Other product name, brand names and company names mentioned herein may be trademarks or trade names of their respective owners. WHS is not affiliated with any other names or brands mentioned on this page.
                          </p></div>
                          <div class="col-sm"></div>
                      </div>
                      

          

                  </div>
             </div>

        </div>
</div>



<!--   <div class="container">
<div class="row">
  <div class="col-sm-8">col-sm-8</div>
  <div class="col-sm-4">col-sm-4</div>
</div>
</div>-->
  </form>

  
<script src="../assets/fljs/jquery.min.js"></script> 

<!-- Select menu --> 
 
<!--tabing -->
</body>
</html>


<router-outlet></router-outlet>